import React, { useState, useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { FaCog, FaBars, FaChevronDown, FaChevronRight, FaUser, FaKey, FaCogs, FaGift, FaFingerprint, FaUsers, FaTicketAlt, FaCashRegister, FaPrint, FaPalette, FaCreditCard, FaCubes, FaEnvelope, FaShoppingCart, FaDollarSign, FaSave, FaCheck, FaPlus, FaTimes, FaTrash, FaPaperPlane, FaNetworkWired, FaPlug, FaSpinner, FaDatabase, FaTable, FaSearch, FaCheckSquare, FaSquare, FaImage, FaUpload, FaFolder, FaKey as FaLicencia, FaShieldAlt, FaDesktop, FaCalendarAlt, FaUnlink } from 'react-icons/fa';
import './Configuracion.css';
import { getApiUrl } from '../../utils/api';
import PrecioDelivery from './PrecioDelivery';

const Configuracion = () => {
  const [menuAbierto, setMenuAbierto] = useState(true);
  const [vistaActual, setVistaActual] = useState('autorizacion-supervisor');
  const [itemsColapsados, setItemsColapsados] = useState({
    supervisor: false, // Supervisor expandido por defecto
    cuentas: true,
    tickets: true,
    caja: true,
    imprimir: true,
    diseno: true,
    tarjeta: true,
    modulos: true,
    email: true,
    compras: true,
    configuracion: true,
    gastos: true,
    biometrico: true,
    licencia: true
  });
  const toast = useToast();

  const [configuracionSupervisor, setConfiguracionSupervisor] = useState({
    descuentosCortesias: true,
    cancelarPedidos: true,
    borrarModificarCantidades: true,
    cambiarPrecioPlatillos: true
  });

  const [guardando, setGuardando] = useState(false);

  const [fondoDeCaja, setFondoDeCaja] = useState('4000.00');

  const [registroIP, setRegistroIP] = useState({
    modulo: '',
    nombre: '',
    ip: ['192', '168', '1', '68'],
    tipo: 'caja'
  });

  const [modulosRegistrados, setModulosRegistrados] = useState([]);

  const [configEmail, setConfigEmail] = useState({
    sucursal: 'Norte',
    cuentaCortes: '',
    enviarEmailCorte: false,
    cuentaCriticos: 'kathialmg@gmail.com',
    enviarCriticosCorte: true
  });

  // Estado para configuración del biométrico ZKTeco
  const [configBiometrico, setConfigBiometrico] = useState({
    // Configuración del dispositivo
    nombreDispositivo: '',
    ip: ['192', '168', '1', '201'],
    puerto: '4370',
    timeout: '10000',
    autoConectar: true,
    modelo: 'MB360',
    // Configuración del servidor de base de datos
    servidorDB: '',
    usuarioDB: '',
    passwordDB: '',
    baseDatos: '',
    // Configuración de tablas
    tablaRegistros: 'registro',
    tablaHuellas: 'cat_biometricos_empleados',
    // Ruta de XAMPP
    rutaXampp: 'C:\\xampp'
  });
  const [probandoConexion, setProbandoConexion] = useState(false);
  const [estadoConexion, setEstadoConexion] = useState(null); // null, 'success', 'error'
  const [probandoConexionDB, setProbandoConexionDB] = useState(false);
  const [estadoConexionDB, setEstadoConexionDB] = useState(null); // null, 'success', 'error'

  // Estado para configuración de Licencia
  const [configLicencia, setConfigLicencia] = useState({
    claveLicencia: '',
    urlServidor: ''
  });
  const [estadoLicencia, setEstadoLicencia] = useState(null); // null o objeto con info de licencia
  const [procesandoLicencia, setProcesandoLicencia] = useState(false);
  const [machineId, setMachineId] = useState('');
  const [nombrePC, setNombrePC] = useState('');

  // Estado para configuración de Actualizaciones
  const [updaterUrl, setUpdaterUrl] = useState('');
  const [appVersion, setAppVersion] = useState('');
  const [buscandoUpdate, setBuscandoUpdate] = useState(false);
  const [updateResult, setUpdateResult] = useState(null);
  const [updateProgress, setUpdateProgress] = useState(null);

  // Estado para replicación de base de datos
  const [configReplicacion, setConfigReplicacion] = useState({
    // Local
    localServidor: 'localhost',
    localUsuario: 'root',
    localPassword: '',
    localBaseDatos: 'kapital_padel',
    rutaXampp: 'C:\\xampp',
    // Remoto
    remotoServidor: '',
    remotoUsuario: '',
    remotoPassword: '',
    remotoBaseDatos: '',
    remotoPuerto: '3306'
  });
  const [tablasDisponibles, setTablasDisponibles] = useState([]);
  const [tablasSeleccionadas, setTablasSeleccionadas] = useState([]);
  const [cargandoTablas, setCargandoTablas] = useState(false);
  const [probandoRemoto, setProbandoRemoto] = useState(false);
  const [estadoRemoto, setEstadoRemoto] = useState(null);
  const [replicando, setReplicando] = useState(false);
  const [progresoReplicacion, setProgresoReplicacion] = useState(null);
  const [resultadoReplicacion, setResultadoReplicacion] = useState(null);
  const [autoReplicarActivo, setAutoReplicarActivo] = useState(false);
  const [ultimaReplicacionAuto, setUltimaReplicacionAuto] = useState(null);

  // Estado para configuración de Impresión por Platillo
  const [platillosImpresora, setPlatillosImpresora] = useState([]);
  const [impresoras, setImpresoras] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [platillosSeleccionados, setPlatillosSeleccionados] = useState([]);
  const [impresoraAsignar, setImpresoraAsignar] = useState('');
  const [cargandoPlatillos, setCargandoPlatillos] = useState(false);

  // Filtros por columna (tipo Excel)
  const [filtrosColumna, setFiltrosColumna] = useState({
    nombre: '',
    categoria: '',
    impresora: '',
    impresoraCategoria: ''
  });

  // === Estado para configuración de Tickets ===
  const [infoNegocio, setInfoNegocio] = useState({
    nombre_negocio: '', nombre_sucursal: '',
    direccion_linea1: '', direccion_linea2: '',
    razon_social: '', rfc: '', telefono: '',
    email: '', sitio_web: '', mensaje_ticket: ''
  });
  const [cargandoInfoNegocio, setCargandoInfoNegocio] = useState(false);

  const [camposEncabezadoCuenta, setCamposEncabezadoCuenta] = useState({
    nombre_negocio: true, nombre_sucursal: true,
    direccion_linea1: true, direccion_linea2: true,
    razon_social: false, rfc: true, telefono: true
  });

  const [finTicketCuenta, setFinTicketCuenta] = useState({
    linea1: 'GRACIAS POR SU PREFERENCIA', linea2: '', linea3: ''
  });

  const [encabezadoReporte, setEncabezadoReporte] = useState({
    mostrarNombreNegocio: true, mostrarSucursal: true,
    mostrarDireccion: false, mostrarRFC: true
  });

  const [finTicketReporte, setFinTicketReporte] = useState({
    linea1: '', linea2: '',
    mostrarLineaFirma: true, textoFirma: 'Firma del Responsable'
  });

  const [ordenProductos, setOrdenProductos] = useState({
    criterio: 'categoria', agruparPorCategoria: true, ordenAscendente: true
  });

  const [configFacturacion, setConfigFacturacion] = useState({
    leyandaInicio: '', Leyenda: '', linkFactura: false
  });

  // Estado para logo del ticket
  const [ticketLogo, setTicketLogo] = useState('');
  const [logoEnabled, setLogoEnabled] = useState(false);

  // Cargar info del negocio cuando se selecciona una vista de tickets
  // Cerrar sidebar automáticamente en pantallas 1024px o menores
  useEffect(() => {
    if (window.innerWidth <= 1024) setMenuAbierto(false);
  }, []);

  useEffect(() => {
    const vistasTicket = ['encabezado-ticket-cuenta', 'fin-ticket-cuenta', 'encabezado-ticket-reporte', 'fin-ticket-reporte'];
    if (vistasTicket.includes(vistaActual)) {
      cargarInfoNegocio();
    }
  }, [vistaActual]);

  // Cargar configuración de tickets desde localStorage
  useEffect(() => {
    try {
      const saved = {
        camposEncabezado: localStorage.getItem('ticket_campos_encabezado_cuenta'),
        finCuenta: localStorage.getItem('ticket_fin_cuenta'),
        encabezadoReporte: localStorage.getItem('ticket_encabezado_reporte'),
        finReporte: localStorage.getItem('ticket_fin_reporte'),
        ordenProductos: localStorage.getItem('ticket_orden_productos')
      };
      if (saved.camposEncabezado) setCamposEncabezadoCuenta(JSON.parse(saved.camposEncabezado));
      if (saved.finCuenta) setFinTicketCuenta(JSON.parse(saved.finCuenta));
      if (saved.encabezadoReporte) setEncabezadoReporte(JSON.parse(saved.encabezadoReporte));
      if (saved.finReporte) setFinTicketReporte(JSON.parse(saved.finReporte));
      if (saved.ordenProductos) setOrdenProductos(JSON.parse(saved.ordenProductos));
      // Cargar logo del ticket
      const savedLogo = localStorage.getItem('ticket_logo_base64');
      const savedLogoEnabled = localStorage.getItem('ticket_logo_enabled');
      if (savedLogo) setTicketLogo(savedLogo);
      if (savedLogoEnabled !== null) setLogoEnabled(savedLogoEnabled === 'true');
      // Cargar configuración de facturación desde BD
      cargarConfigFacturacion();
    } catch (e) { console.error('Error cargando config tickets:', e); }
  }, []);

  const cargarConfigFacturacion = async () => {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'getSystemConfig' })
      });
      const data = await response.json();
      if (data.success && data.data) {
        const sc = data.data;
        setConfigFacturacion({
          leyandaInicio: sc.leyandaInicio || '',
          Leyenda: sc.Leyenda || '',
          linkFactura: sc.linkFactura === 1 || sc.linkFactura === '1' || sc.linkFactura === true
        });
      }
    } catch (e) {
      console.error('Error cargando config facturación desde BD:', e);
      // Fallback a localStorage
      const sc = JSON.parse(localStorage.getItem('systemConfig') || '{}');
      setConfigFacturacion({
        leyandaInicio: sc.leyandaInicio || '',
        Leyenda: sc.Leyenda || '',
        linkFactura: sc.linkFactura === 1 || sc.linkFactura === '1'
      });
    }
  };

  const cargarInfoNegocio = async () => {
    setCargandoInfoNegocio(true);
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'getInfoNegocio' })
      });
      const data = await response.json();
      if (data.success && data.data) {
        const d = data.data;
        setInfoNegocio({
          nombre_negocio: d.nombre_negocio || '', nombre_sucursal: d.nombre_sucursal || '',
          direccion_linea1: d.direccion_linea1 || '', direccion_linea2: d.direccion_linea2 || '',
          razon_social: d.razon_social || '', rfc: d.rfc || '', telefono: d.telefono || '',
          email: d.email || '', sitio_web: d.sitio_web || '', mensaje_ticket: d.mensaje_ticket || ''
        });
      }
    } catch (error) {
      console.error('Error al cargar info del negocio:', error);
    } finally {
      setCargandoInfoNegocio(false);
    }
  };

  // Cargar platillos e impresoras cuando se selecciona la vista de impresión por platillo
  useEffect(() => {
    if (vistaActual === 'impresion-platillo') {
      cargarDatosImpresionPlatillo();
    }
  }, [vistaActual]);

  const cargarDatosImpresionPlatillo = async () => {
    setCargandoPlatillos(true);
    try {
      // Cargar platillos y categorías desde la API
      const [resPlatillos, resCategorias] = await Promise.all([
        fetch(getApiUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tipo: 'getPlatillosParaImpresora' })
        }),
        fetch(getApiUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tipo: 'getCategorias' })
        })
      ]);

      const dataPlatillos = await resPlatillos.json();
      const dataCategorias = await resCategorias.json();

      if (dataPlatillos.success) {
        setPlatillosImpresora(dataPlatillos.data || []);
      }
      if (dataCategorias.success) {
        setCategorias(dataCategorias.data || []);
      }

      // Cargar impresoras del sistema operativo (Windows)
      if (window.electron && window.electron.ipcRenderer) {
        try {
          const systemPrinters = await window.electron.ipcRenderer.invoke('get-all-printers');
          if (Array.isArray(systemPrinters)) {
            const impresorasFormateadas = systemPrinters.map((printer, index) => ({
              id: index + 1,
              nombre: printer.name,
              displayName: printer.displayName || printer.name,
              isDefault: printer.isDefault,
              status: printer.status
            }));
            setImpresoras(impresorasFormateadas);
          }
        } catch (printerError) {
          console.error('Error al obtener impresoras del sistema:', printerError);
          toast.error('No se pudieron cargar las impresoras del sistema');
        }
      } else {
        console.warn('Electron no disponible, no se pueden cargar impresoras del sistema');
        toast.warning('Ejecuta la aplicación en Electron para ver las impresoras');
      }
    } catch (error) {
      console.error('Error al cargar datos:', error);
      toast.error('Error al cargar los datos');
    } finally {
      setCargandoPlatillos(false);
    }
  };

  // Filtrado por columnas (tipo Excel)
  const platillosFiltrados = platillosImpresora.filter(p => {
    const cumpleNombre = !filtrosColumna.nombre ||
      p.nombre.toLowerCase().includes(filtrosColumna.nombre.toLowerCase());

    const cumpleCategoria = !filtrosColumna.categoria ||
      p.nombreCategoria.toLowerCase().includes(filtrosColumna.categoria.toLowerCase());

    const cumpleImpresora = !filtrosColumna.impresora ||
      (filtrosColumna.impresora === '__sin_asignar__'
        ? !p.impresora
        : (p.impresora && p.impresora.toLowerCase().includes(filtrosColumna.impresora.toLowerCase())));

    const cumpleImpresoraCat = !filtrosColumna.impresoraCategoria ||
      (p.impresoraCategoria && p.impresoraCategoria.toLowerCase().includes(filtrosColumna.impresoraCategoria.toLowerCase()));

    return cumpleNombre && cumpleCategoria && cumpleImpresora && cumpleImpresoraCat;
  });

  const handleFiltroColumnaChange = (columna, valor) => {
    setFiltrosColumna(prev => ({
      ...prev,
      [columna]: valor
    }));
    setPlatillosSeleccionados([]); // Limpiar selección al filtrar
  };

  const limpiarFiltros = () => {
    setFiltrosColumna({
      nombre: '',
      categoria: '',
      impresora: '',
      impresoraCategoria: ''
    });
    setPlatillosSeleccionados([]);
  };

  // Obtener valores únicos para los selects de filtro
  const categoriasUnicas = [...new Set(platillosImpresora.map(p => p.nombreCategoria))].sort();
  const impresorasUnicas = [...new Set(platillosImpresora.map(p => p.impresora).filter(Boolean))].sort();
  const impresorasCatUnicas = [...new Set(platillosImpresora.map(p => p.impresoraCategoria).filter(Boolean))].sort();

  const handleSeleccionarPlatillo = (idPlatillo) => {
    setPlatillosSeleccionados(prev => {
      if (prev.includes(idPlatillo)) {
        return prev.filter(id => id !== idPlatillo);
      } else {
        return [...prev, idPlatillo];
      }
    });
  };

  const handleSeleccionarTodos = () => {
    if (platillosSeleccionados.length === platillosFiltrados.length) {
      setPlatillosSeleccionados([]);
    } else {
      setPlatillosSeleccionados(platillosFiltrados.map(p => p.idPlatillo));
    }
  };

  const handleAsignarImpresora = async () => {
    if (platillosSeleccionados.length === 0) {
      toast.error('Selecciona al menos un platillo');
      return;
    }

    if (!impresoraAsignar) {
      toast.error('Selecciona una impresora para asignar');
      return;
    }

    setGuardando(true);
    try {
      const platillosActualizar = platillosSeleccionados.map(id => ({
        idPlatillo: id,
        impresora: impresoraAsignar
      }));

      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'actualizarImpresorasPlatillos',
          platillos: platillosActualizar
        })
      });

      const data = await response.json();

      if (data.success) {
        toast.success(`Impresora asignada a ${platillosSeleccionados.length} platillo(s)`);
        // Actualizar la lista local
        setPlatillosImpresora(prev => prev.map(p => {
          if (platillosSeleccionados.includes(p.idPlatillo)) {
            return { ...p, impresora: impresoraAsignar };
          }
          return p;
        }));
        setPlatillosSeleccionados([]);
        setImpresoraAsignar('');
      } else {
        toast.error(data.message || 'Error al asignar impresora');
      }
    } catch (error) {
      console.error('Error al asignar impresora:', error);
      toast.error('Error al asignar la impresora');
    } finally {
      setGuardando(false);
    }
  };

  const handleQuitarImpresora = async () => {
    if (platillosSeleccionados.length === 0) {
      toast.error('Selecciona al menos un platillo');
      return;
    }

    setGuardando(true);
    try {
      const platillosActualizar = platillosSeleccionados.map(id => ({
        idPlatillo: id,
        impresora: ''
      }));

      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'actualizarImpresorasPlatillos',
          platillos: platillosActualizar
        })
      });

      const data = await response.json();

      if (data.success) {
        toast.success(`Impresora removida de ${platillosSeleccionados.length} platillo(s)`);
        setPlatillosImpresora(prev => prev.map(p => {
          if (platillosSeleccionados.includes(p.idPlatillo)) {
            return { ...p, impresora: '' };
          }
          return p;
        }));
        setPlatillosSeleccionados([]);
      } else {
        toast.error(data.message || 'Error al quitar impresora');
      }
    } catch (error) {
      console.error('Error al quitar impresora:', error);
      toast.error('Error al quitar la impresora');
    } finally {
      setGuardando(false);
    }
  };

  // Cargar configuración del biométrico desde localStorage
  useEffect(() => {
    const savedNombreDispositivo = localStorage.getItem('biometrico_nombre_dispositivo');
    const savedIP = localStorage.getItem('biometrico_ip');
    const savedPort = localStorage.getItem('biometrico_port');
    const savedTimeout = localStorage.getItem('biometrico_timeout');
    const savedAutoConectar = localStorage.getItem('biometrico_autoconectar');

    if (savedNombreDispositivo) {
      setConfigBiometrico(prev => ({ ...prev, nombreDispositivo: savedNombreDispositivo }));
    }
    if (savedIP) {
      const ipParts = savedIP.split('.');
      if (ipParts.length === 4) {
        setConfigBiometrico(prev => ({ ...prev, ip: ipParts }));
      }
    }
    if (savedPort) {
      setConfigBiometrico(prev => ({ ...prev, puerto: savedPort }));
    }
    if (savedTimeout) {
      setConfigBiometrico(prev => ({ ...prev, timeout: savedTimeout }));
    }
    if (savedAutoConectar !== null) {
      setConfigBiometrico(prev => ({ ...prev, autoConectar: savedAutoConectar === 'true' }));
    }
    const savedModelo = localStorage.getItem('biometrico_modelo');
    if (savedModelo) {
      setConfigBiometrico(prev => ({ ...prev, modelo: savedModelo }));
    }

    // Cargar configuración del servidor de base de datos
    const savedServidorDB = localStorage.getItem('biometrico_servidor_db');
    const savedUsuarioDB = localStorage.getItem('biometrico_usuario_db');
    const savedPasswordDB = localStorage.getItem('biometrico_password_db');
    const savedBaseDatos = localStorage.getItem('biometrico_base_datos');
    const savedTablaRegistros = localStorage.getItem('biometrico_tabla_registros');
    const savedTablaHuellas = localStorage.getItem('biometrico_tabla_huellas');

    if (savedServidorDB) {
      setConfigBiometrico(prev => ({ ...prev, servidorDB: savedServidorDB }));
    }
    if (savedUsuarioDB) {
      setConfigBiometrico(prev => ({ ...prev, usuarioDB: savedUsuarioDB }));
    }
    if (savedPasswordDB) {
      setConfigBiometrico(prev => ({ ...prev, passwordDB: savedPasswordDB }));
    }
    if (savedBaseDatos) {
      setConfigBiometrico(prev => ({ ...prev, baseDatos: savedBaseDatos }));
    }
    if (savedTablaRegistros) {
      setConfigBiometrico(prev => ({ ...prev, tablaRegistros: savedTablaRegistros }));
    }
    if (savedTablaHuellas) {
      setConfigBiometrico(prev => ({ ...prev, tablaHuellas: savedTablaHuellas }));
    }
    const savedRutaXampp = localStorage.getItem('biometrico_ruta_xampp');
    if (savedRutaXampp) {
      setConfigBiometrico(prev => ({ ...prev, rutaXampp: savedRutaXampp }));
    }

    // Cargar configuración de licencia desde API local
    const API_LOCAL = getApiUrl();

    // Obtener machine ID (fallback para navegador)
    setMachineId('web-' + navigator.userAgent.length + '-' + (navigator.hardwareConcurrency || 0));
    setNombrePC('Navegador');
    if (window.licenciaAPI) {
      window.licenciaAPI.getMachineId().then(result => {
        if (result.success) {
          setMachineId(result.machineId);
          setNombrePC(result.nombrePC);
        }
      });
    }

    // Cargar URL del servidor desde BD local
    fetch(API_LOCAL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tipo: 'getUrlServidor' })
    }).then(r => r.json()).then(res => {
      if (res.success && res.data?.url_servidor) {
        setConfigLicencia(prev => ({ ...prev, urlServidor: res.data.url_servidor }));
      }
    }).catch(() => {});

    // Cargar estado de licencia desde BD local
    const getMachineIdPromise = window.licenciaAPI
      ? window.licenciaAPI.getMachineId().then(r => r.success ? r.machineId : 'web-' + navigator.userAgent.length)
      : Promise.resolve('web-' + navigator.userAgent.length + '-' + (navigator.hardwareConcurrency || 0));

    getMachineIdPromise.then(currentMachineId => {
      fetch(API_LOCAL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'verificarLicencia', machine_id: currentMachineId })
      }).then(r => r.json()).then(res => {
        if (res.success) {
          setEstadoLicencia(res.data);
          if (res.data?.clave_licencia) {
            setConfigLicencia(prev => ({ ...prev, claveLicencia: res.data.clave_licencia }));
          }
        }
      }).catch(() => {});
    });

    // Cargar configuración de actualizaciones
    const savedUpdaterUrl = localStorage.getItem('updater_url');
    if (savedUpdaterUrl) {
      setUpdaterUrl(savedUpdaterUrl);
    }
    let removeUpdateListener = null;
    if (window.updaterAPI) {
      window.updaterAPI.getVersion().then(result => {
        setAppVersion(result.version || '');
      });
      removeUpdateListener = window.updaterAPI.onUpdateStatus((data) => {
        switch (data.status) {
          case 'checking':
            setUpdateResult({ type: 'info', message: 'Buscando actualizaciones...' });
            setUpdateProgress(null);
            break;
          case 'available':
            setUpdateResult({ type: 'info', message: `Actualización v${data.version} disponible. Descargando...` });
            break;
          case 'not-available':
            setUpdateResult({ type: 'success', message: 'No hay actualizaciones disponibles. Estás en la última versión.' });
            setBuscandoUpdate(false);
            break;
          case 'downloading':
            setUpdateProgress(data.percent);
            setUpdateResult({ type: 'info', message: `Descargando actualización... ${data.percent}%` });
            break;
          case 'downloaded':
            setUpdateResult({ type: 'success', message: `Actualización v${data.version} descargada. Se instalará en breve.` });
            setUpdateProgress(100);
            setBuscandoUpdate(false);
            break;
          case 'error':
            setUpdateResult({ type: 'error', message: `Error: ${data.message}` });
            setUpdateProgress(null);
            setBuscandoUpdate(false);
            break;
          default:
            break;
        }
      });
    }
    // Cargar configuración de replicación desde archivo
    let removeReplicacionListener = null;
    let removeAutoResultadoListener = null;
    if (window.replicacionAPI) {
      window.replicacionAPI.leerConfig().then(result => {
        if (result.success && result.data) {
          setConfigReplicacion(result.data);
        }
      }).catch(() => {});

      // Verificar si el servicio auto está activo
      window.replicacionAPI.estadoAuto().then(result => {
        setAutoReplicarActivo(result.activo);
      }).catch(() => {});

      // Listener de progreso de replicación manual
      removeReplicacionListener = window.replicacionAPI.onProgreso((data) => {
        setProgresoReplicacion(data);
      });

      // Listener de resultado de replicación automática
      removeAutoResultadoListener = window.replicacionAPI.onAutoResultado((data) => {
        setUltimaReplicacionAuto(data);
      });
    }

    return () => {
      if (removeUpdateListener) removeUpdateListener();
      if (removeReplicacionListener) removeReplicacionListener();
      if (removeAutoResultadoListener) removeAutoResultadoListener();
    };
  }, []);

  // Manejar navegación del menú
  const toggleMenuItem = (item) => {
    setItemsColapsados({
      ...itemsColapsados,
      [item]: !itemsColapsados[item]
    });
  };

  const cambiarVista = (vista) => {
    setVistaActual(vista);
    // En pantallas pequeñas, cerrar el sidebar al navegar
    if (window.innerWidth <= 1024) setMenuAbierto(false);
  };

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  const handleCheckboxChange = (key) => {
    setConfiguracionSupervisor(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleGuardarSupervisor = async () => {
    try {
      setGuardando(true);
      await new Promise(resolve => setTimeout(resolve, 1000));
      toast.success('Configuración guardada correctamente');
    } catch (error) {
      console.error('Error al guardar configuración:', error);
      toast.error('Error al guardar la configuración');
    } finally {
      setGuardando(false);
    }
  };

  const handleGuardarFondoCaja = async () => {
    try {
      setGuardando(true);
      await new Promise(resolve => setTimeout(resolve, 1000));
      toast.success('Fondo de caja guardado correctamente');
    } catch (error) {
      console.error('Error al guardar fondo de caja:', error);
      toast.error('Error al guardar el fondo de caja');
    } finally {
      setGuardando(false);
    }
  };

  const handleFondoCajaChange = (e) => {
    const value = e.target.value;
    // Solo permitir números y punto decimal
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setFondoDeCaja(value);
    }
  };

  const handleIPChange = (index, value) => {
    // Solo permitir números y máximo 3 dígitos
    if (/^\d{0,3}$/.test(value) && (value === '' || parseInt(value) <= 255)) {
      const newIP = [...registroIP.ip];
      newIP[index] = value;
      setRegistroIP({ ...registroIP, ip: newIP });
    }
  };

  const handleGuardarModulo = () => {
    if (!registroIP.nombre || registroIP.ip.some(part => part === '')) {
      toast.error('Por favor completa todos los campos');
      return;
    }

    const nuevoModulo = {
      id: Date.now(),
      modulo: registroIP.modulo || registroIP.nombre,
      nombre: registroIP.nombre,
      ip: registroIP.ip.join('.'),
      tipo: registroIP.tipo
    };

    setModulosRegistrados([...modulosRegistrados, nuevoModulo]);
    setRegistroIP({
      modulo: '',
      nombre: '',
      ip: ['192', '168', '1', '68'],
      tipo: 'caja'
    });
    toast.success('Módulo registrado correctamente');
  };

  const handleEliminarModulo = (id) => {
    setModulosRegistrados(modulosRegistrados.filter(m => m.id !== id));
    toast.success('Módulo eliminado correctamente');
  };

  const handleGuardarConfigEmail = async () => {
    try {
      setGuardando(true);
      await new Promise(resolve => setTimeout(resolve, 1000));
      toast.success('Configuración de email guardada correctamente');
    } catch (error) {
      console.error('Error al guardar configuración de email:', error);
      toast.error('Error al guardar la configuración');
    } finally {
      setGuardando(false);
    }
  };

  const handleEnviarPrueba = () => {
    toast.info('Enviando correo de prueba...');
    setTimeout(() => {
      toast.success('Correo de prueba enviado correctamente');
    }, 1500);
  };

  // === Handlers para Tickets ===
  const guardarInfoNegocioAPI = async () => {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'actualizarInfoNegocio', ...infoNegocio })
      });
      const data = await response.json();
      if (!data.success) throw new Error(data.message);
      return true;
    } catch (error) {
      console.error('Error al guardar info negocio:', error);
      toast.error('Error al guardar la información del negocio');
      return false;
    }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      toast.error('Solo se permiten archivos de imagen');
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        const MAX_WIDTH = 280;
        let width = img.width;
        let height = img.height;
        if (width > MAX_WIDTH) {
          height = Math.round(height * (MAX_WIDTH / width));
          width = MAX_WIDTH;
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        const base64 = canvas.toDataURL('image/jpeg', 0.7);
        setTicketLogo(base64);
        setLogoEnabled(true);
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  const handleLogoRemove = () => {
    setTicketLogo('');
    setLogoEnabled(false);
    localStorage.removeItem('ticket_logo_base64');
    localStorage.removeItem('ticket_logo_enabled');
  };

  const handleGuardarEncabezadoCuenta = async () => {
    setGuardando(true);
    localStorage.setItem('ticket_campos_encabezado_cuenta', JSON.stringify(camposEncabezadoCuenta));
    if (ticketLogo) {
      localStorage.setItem('ticket_logo_base64', ticketLogo);
    } else {
      localStorage.removeItem('ticket_logo_base64');
    }
    localStorage.setItem('ticket_logo_enabled', logoEnabled.toString());
    const ok = await guardarInfoNegocioAPI();
    if (ok) toast.success('Encabezado de ticket guardado correctamente');
    setGuardando(false);
  };

  const handleGuardarFinCuenta = async () => {
    setGuardando(true);
    localStorage.setItem('ticket_fin_cuenta', JSON.stringify(finTicketCuenta));
    // Guardar campos de facturación en BD (tabla system)
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'actualizarSystemConfig',
          linkFactura: configFacturacion.linkFactura ? 1 : 0,
          leyandaInicio: configFacturacion.leyandaInicio,
          Leyenda: configFacturacion.Leyenda
        })
      });
      const result = await response.json();
      if (result.success && result.data) {
        // Sincronizar localStorage con lo que devolvió la BD
        const sc = JSON.parse(localStorage.getItem('systemConfig') || '{}');
        sc.leyandaInicio = result.data.leyandaInicio;
        sc.Leyenda = result.data.Leyenda;
        sc.linkFactura = result.data.linkFactura;
        localStorage.setItem('systemConfig', JSON.stringify(sc));
      }
    } catch (e) { console.error('Error guardando config facturación en BD:', e); }
    const ok = await guardarInfoNegocioAPI();
    if (ok) toast.success('Pie de ticket guardado correctamente');
    setGuardando(false);
  };

  const handleGuardarEncabezadoReporte = () => {
    localStorage.setItem('ticket_encabezado_reporte', JSON.stringify(encabezadoReporte));
    toast.success('Encabezado de reporte guardado correctamente');
  };

  const handleGuardarFinReporte = () => {
    localStorage.setItem('ticket_fin_reporte', JSON.stringify(finTicketReporte));
    toast.success('Pie de reporte guardado correctamente');
  };

  const handleGuardarOrdenProductos = () => {
    localStorage.setItem('ticket_orden_productos', JSON.stringify(ordenProductos));
    toast.success('Orden de productos guardado correctamente');
  };

  // Handlers para configuración del biométrico
  const handleBiometricoIPChange = (index, value) => {
    if (/^\d{0,3}$/.test(value) && (value === '' || parseInt(value) <= 255)) {
      const newIP = [...configBiometrico.ip];
      newIP[index] = value;
      setConfigBiometrico({ ...configBiometrico, ip: newIP });
      setEstadoConexion(null);
    }
  };

  const handleGuardarBiometrico = async () => {
    try {
      setGuardando(true);

      // Validar IP
      if (configBiometrico.ip.some(part => part === '' || parseInt(part) > 255)) {
        toast.error('Dirección IP inválida');
        return;
      }

      // Validar puerto
      const puerto = parseInt(configBiometrico.puerto);
      if (isNaN(puerto) || puerto < 1 || puerto > 65535) {
        toast.error('Puerto inválido (debe ser entre 1 y 65535)');
        return;
      }

      // Guardar configuración del dispositivo en localStorage
      const ipCompleta = configBiometrico.ip.join('.');
      localStorage.setItem('biometrico_nombre_dispositivo', configBiometrico.nombreDispositivo);
      localStorage.setItem('biometrico_ip', ipCompleta);
      localStorage.setItem('biometrico_port', configBiometrico.puerto);
      localStorage.setItem('biometrico_timeout', configBiometrico.timeout);
      localStorage.setItem('biometrico_autoconectar', configBiometrico.autoConectar.toString());
      localStorage.setItem('biometrico_modelo', configBiometrico.modelo);

      // Guardar configuración del servidor de base de datos
      localStorage.setItem('biometrico_servidor_db', configBiometrico.servidorDB);
      localStorage.setItem('biometrico_usuario_db', configBiometrico.usuarioDB);
      localStorage.setItem('biometrico_password_db', configBiometrico.passwordDB);
      localStorage.setItem('biometrico_base_datos', configBiometrico.baseDatos);
      localStorage.setItem('biometrico_tabla_registros', configBiometrico.tablaRegistros);
      localStorage.setItem('biometrico_tabla_huellas', configBiometrico.tablaHuellas);
      localStorage.setItem('biometrico_ruta_xampp', configBiometrico.rutaXampp);

      toast.success('Configuración del biométrico guardada correctamente');
    } catch (error) {
      console.error('Error al guardar configuración del biométrico:', error);
      toast.error('Error al guardar la configuración');
    } finally {
      setGuardando(false);
    }
  };

  const handleProbarConexionBiometrico = async () => {
    try {
      setProbandoConexion(true);
      setEstadoConexion(null);

      const ipCompleta = configBiometrico.ip.join('.');
      const puerto = parseInt(configBiometrico.puerto);

      toast.info(`Probando conexión a ${ipCompleta}:${puerto}...`);

      // Verificar si estamos en Electron
      if (window.biometrico && window.biometrico.connect) {
        const response = await window.biometrico.connect({
          ip: ipCompleta,
          port: puerto,
          timeout: parseInt(configBiometrico.timeout)
        });

        if (response && response.success) {
          setEstadoConexion('success');
          toast.success('Conexión exitosa con el dispositivo biométrico');

          // Desconectar después de la prueba
          if (window.biometrico.disconnectDevice) {
            await window.biometrico.disconnectDevice();
          }
        } else {
          setEstadoConexion('error');
          toast.error(response?.message || 'No se pudo conectar al dispositivo');
        }
      } else {
        // Simulación para desarrollo
        await new Promise(resolve => setTimeout(resolve, 2000));
        setEstadoConexion('success');
        toast.success('Conexión simulada exitosa (modo desarrollo)');
      }
    } catch (error) {
      console.error('Error al probar conexión:', error);
      setEstadoConexion('error');
      toast.error('Error al probar la conexión: ' + error.message);
    } finally {
      setProbandoConexion(false);
    }
  };

  const handleProbarConexionDB = async () => {
    if (!configBiometrico.servidorDB || !configBiometrico.usuarioDB || !configBiometrico.baseDatos) {
      toast.error('Completa servidor, usuario y base de datos');
      return;
    }

    if (!window.replicacionAPI) {
      toast.error('La prueba de conexión solo funciona en la versión de escritorio');
      setEstadoConexionDB('error');
      return;
    }

    try {
      setProbandoConexionDB(true);
      setEstadoConexionDB(null);

      const result = await window.replicacionAPI.checkRemoteConnection({
        servidor: configBiometrico.servidorDB,
        puerto: '3306',
        usuario: configBiometrico.usuarioDB,
        password: configBiometrico.passwordDB,
        baseDatos: configBiometrico.baseDatos,
        rutaXampp: configBiometrico.rutaXampp
      });

      if (result.success) {
        setEstadoConexionDB('success');
        toast.success('Conexión exitosa al servidor de base de datos');
      } else {
        setEstadoConexionDB('error');
        toast.error(result.message || 'No se pudo conectar a la base de datos');
      }
    } catch (error) {
      setEstadoConexionDB('error');
      toast.error('Error al probar la conexión: ' + error.message);
    } finally {
      setProbandoConexionDB(false);
    }
  };

  // Handlers para configuración de licencia
  const API_LICENCIA = getApiUrl();

  const handleGuardarConfigLicencia = async () => {
    try {
      const response = await fetch(API_LICENCIA, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipo: 'setUrlServidor', url_servidor: configLicencia.urlServidor })
      });
      const result = await response.json();
      if (result.success) {
        toast.success('URL del servidor guardada en la base de datos');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Error al guardar: ' + error.message);
    }
  };

  const handleActivarLicencia = async () => {
    if (!configLicencia.claveLicencia.trim()) {
      toast.error('Ingrese una clave de licencia');
      return;
    }
    if (!configLicencia.urlServidor.trim()) {
      toast.error('Ingrese la URL del servidor');
      return;
    }

    try {
      setProcesandoLicencia(true);

      // Llamar API local que activa contra servidor remoto y guarda en BD local
      const response = await fetch(API_LICENCIA, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'activarLicencia',
          clave_licencia: configLicencia.claveLicencia,
          machine_id: machineId,
          nombre_pc: nombrePC,
          url_servidor: configLicencia.urlServidor
        })
      });

      const result = await response.json();

      if (result.success) {
        setEstadoLicencia(result.data);
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Error de conexión con API local: ' + error.message);
    } finally {
      setProcesandoLicencia(false);
    }
  };

  const handleVerificarLicencia = async () => {
    try {
      setProcesandoLicencia(true);

      const response = await fetch(API_LICENCIA, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'verificarLicencia',
          machine_id: machineId
        })
      });

      const result = await response.json();

      if (result.success) {
        setEstadoLicencia(result.data);
        toast.success('Licencia verificada correctamente (' + (result.data.modo || 'online') + ')');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Error de conexión con API local: ' + error.message);
    } finally {
      setProcesandoLicencia(false);
    }
  };

  const handleDesactivarLicencia = async () => {
    try {
      setProcesandoLicencia(true);

      const response = await fetch(API_LICENCIA, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'desactivarLicencia',
          machine_id: machineId
        })
      });

      const result = await response.json();

      if (result.success) {
        setEstadoLicencia(null);
        setConfigLicencia(prev => ({ ...prev, claveLicencia: '' }));
        toast.success('Licencia desactivada de este dispositivo');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Error de conexión con API local: ' + error.message);
    } finally {
      setProcesandoLicencia(false);
    }
  };

  // Handlers para actualizaciones
  const handleGuardarUpdaterUrl = () => {
    if (!updaterUrl.trim()) {
      toast.error('Ingrese una URL válida');
      return;
    }
    localStorage.setItem('updater_url', updaterUrl.trim());
    if (window.updaterAPI) {
      window.updaterAPI.setUpdateURL(updaterUrl.trim());
    }
    toast.success('URL de actualizaciones guardada');
  };

  const handleBuscarActualizaciones = async () => {
    if (!window.updaterAPI) {
      toast.error('El actualizador solo funciona en la versión de escritorio');
      return;
    }
    try {
      setBuscandoUpdate(true);
      setUpdateResult(null);
      const result = await window.updaterAPI.checkForUpdates();
      if (result.success) {
        setUpdateResult({ type: 'info', message: 'Verificando... Si hay actualización se iniciará la descarga automáticamente.' });
      } else {
        setUpdateResult({ type: 'success', message: result.message || 'No hay actualizaciones disponibles' });
      }
    } catch (error) {
      setUpdateResult({ type: 'error', message: error.message });
    } finally {
      setBuscandoUpdate(false);
    }
  };

  // Handlers para replicación de base de datos
  const handleGuardarConfigReplicacion = async () => {
    if (!window.replicacionAPI) {
      toast.error('Solo disponible en la versión de escritorio');
      return;
    }
    // Guardar config junto con las tablas seleccionadas
    const configParaGuardar = {
      ...configReplicacion,
      tablasReplicar: tablasSeleccionadas
    };
    const result = await window.replicacionAPI.guardarConfig(configParaGuardar);
    if (result.success) {
      toast.success('Configuración guardada en: ' + result.path);
      // Si la bandera está activa, arrancar el servicio; si no, detenerlo
      if (configReplicacion.autoReplicar === 1 || configReplicacion.autoReplicar === '1') {
        const intervalo = (parseInt(configReplicacion.intervaloSegundos) || 10) * 1000;
        await window.replicacionAPI.iniciarAuto(intervalo);
        setAutoReplicarActivo(true);
        toast.success('Servicio de replicación automática activado');
      } else {
        await window.replicacionAPI.detenerAuto();
        setAutoReplicarActivo(false);
      }
    } else {
      toast.error('Error al guardar: ' + result.message);
    }
  };

  const handleCargarTablas = async () => {
    if (!window.replicacionAPI) {
      toast.error('La replicación solo funciona en la versión de escritorio');
      return;
    }
    try {
      setCargandoTablas(true);
      const config = {
        servidor: configReplicacion.localServidor,
        usuario: configReplicacion.localUsuario,
        password: configReplicacion.localPassword,
        baseDatos: configReplicacion.localBaseDatos,
        rutaXampp: configReplicacion.rutaXampp
      };
      const result = await window.replicacionAPI.getTables(config);
      if (result.success) {
        setTablasDisponibles(result.tablas);
        setTablasSeleccionadas(result.tablas); // Seleccionar todas por defecto
        toast.success(`${result.tablas.length} tablas encontradas`);
      } else {
        toast.error('Error al obtener tablas: ' + result.message);
      }
    } catch (error) {
      toast.error('Error: ' + error.message);
    } finally {
      setCargandoTablas(false);
    }
  };

  const handleProbarConexionRemota = async () => {
    if (!window.replicacionAPI) {
      toast.error('La replicación solo funciona en la versión de escritorio');
      return;
    }
    try {
      setProbandoRemoto(true);
      setEstadoRemoto(null);
      const config = {
        servidor: configReplicacion.remotoServidor,
        puerto: configReplicacion.remotoPuerto,
        usuario: configReplicacion.remotoUsuario,
        password: configReplicacion.remotoPassword,
        baseDatos: configReplicacion.remotoBaseDatos,
        rutaXampp: configReplicacion.rutaXampp
      };
      const result = await window.replicacionAPI.checkRemoteConnection(config);
      setEstadoRemoto(result.success ? 'success' : 'error');
      if (result.success) {
        toast.success('Conexión exitosa al servidor remoto');
      } else {
        toast.error('Error de conexión: ' + result.message);
      }
    } catch (error) {
      setEstadoRemoto('error');
      toast.error('Error: ' + error.message);
    } finally {
      setProbandoRemoto(false);
    }
  };

  const handleToggleTabla = (tabla) => {
    setTablasSeleccionadas(prev =>
      prev.includes(tabla) ? prev.filter(t => t !== tabla) : [...prev, tabla]
    );
  };

  const handleSeleccionarTodas = () => {
    if (tablasSeleccionadas.length === tablasDisponibles.length) {
      setTablasSeleccionadas([]);
    } else {
      setTablasSeleccionadas([...tablasDisponibles]);
    }
  };

  const handleReplicar = async () => {
    if (!window.replicacionAPI) {
      toast.error('La replicación solo funciona en la versión de escritorio');
      return;
    }
    if (tablasSeleccionadas.length === 0) {
      toast.error('Seleccione al menos una tabla para replicar');
      return;
    }
    if (!configReplicacion.remotoServidor || !configReplicacion.remotoUsuario || !configReplicacion.remotoBaseDatos) {
      toast.error('Complete la configuración del servidor remoto');
      return;
    }

    try {
      setReplicando(true);
      setResultadoReplicacion(null);
      setProgresoReplicacion(null);

      const params = {
        local: {
          servidor: configReplicacion.localServidor,
          usuario: configReplicacion.localUsuario,
          password: configReplicacion.localPassword,
          baseDatos: configReplicacion.localBaseDatos,
          rutaXampp: configReplicacion.rutaXampp
        },
        remoto: {
          servidor: configReplicacion.remotoServidor,
          puerto: configReplicacion.remotoPuerto,
          usuario: configReplicacion.remotoUsuario,
          password: configReplicacion.remotoPassword,
          baseDatos: configReplicacion.remotoBaseDatos
        },
        tablas: tablasSeleccionadas
      };

      const result = await window.replicacionAPI.replicar(params);
      setResultadoReplicacion(result);

      if (result.success) {
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Error durante la replicación: ' + error.message);
      setResultadoReplicacion({ success: false, message: error.message });
    } finally {
      setReplicando(false);
    }
  };

  // Renderizar contenido según vista actual
  const renderContenido = () => {
    // Contenido específico para Autorización del Supervisor
    if (vistaActual === 'autorizacion-supervisor') {
      return (
        <div className="config-content-form">
          <div className="config-form-section">
            <div className="config-group">
              <h3 className="config-group-title">Forma de Pagos</h3>
              <div className="config-item">
                <label className="config-checkbox">
                  <input
                    type="checkbox"
                    checked={configuracionSupervisor.descuentosCortesias}
                    onChange={() => handleCheckboxChange('descuentosCortesias')}
                  />
                  <span className="config-checkmark">
                    {configuracionSupervisor.descuentosCortesias && <FaCheck />}
                  </span>
                  <span className="config-label">Descuentos o Cortesías</span>
                </label>
              </div>
            </div>

            <div className="config-group">
              <h3 className="config-group-title">Cancelar un Pedido</h3>
              <div className="config-item">
                <label className="config-checkbox">
                  <input
                    type="checkbox"
                    checked={configuracionSupervisor.cancelarPedidos}
                    onChange={() => handleCheckboxChange('cancelarPedidos')}
                  />
                  <span className="config-checkmark">
                    {configuracionSupervisor.cancelarPedidos && <FaCheck />}
                  </span>
                  <span className="config-label">Cancelar Pedidos</span>
                </label>
              </div>
            </div>

            <div className="config-group">
              <h3 className="config-group-title">Cancelar Productos</h3>
              <div className="config-item">
                <label className="config-checkbox">
                  <input
                    type="checkbox"
                    checked={configuracionSupervisor.borrarModificarCantidades}
                    onChange={() => handleCheckboxChange('borrarModificarCantidades')}
                  />
                  <span className="config-checkmark">
                    {configuracionSupervisor.borrarModificarCantidades && <FaCheck />}
                  </span>
                  <span className="config-label">Borrar o Modificar Cantidades de Productos de comanda</span>
                </label>
              </div>
            </div>

            <div className="config-group">
              <h3 className="config-group-title">Cambiar Precio de Platillos</h3>
              <div className="config-item">
                <label className="config-checkbox">
                  <input
                    type="checkbox"
                    checked={configuracionSupervisor.cambiarPrecioPlatillos}
                    onChange={() => handleCheckboxChange('cambiarPrecioPlatillos')}
                  />
                  <span className="config-checkmark">
                    {configuracionSupervisor.cambiarPrecioPlatillos && <FaCheck />}
                  </span>
                  <span className="config-label">Cambiar el Precio de los Platillos en los Pedidos</span>
                </label>
              </div>
            </div>
          </div>

          <div className="config-form-footer">
            <button
              className="config-btn config-btn-primary"
              onClick={handleGuardarSupervisor}
              disabled={guardando}
            >
              <FaSave /> {guardando ? 'Guardando...' : 'Guardar Configuración'}
            </button>
          </div>
        </div>
      );
    }

    // Contenido específico para Fondo de Caja
    if (vistaActual === 'fondo-de-caja') {
      return (
        <div className="config-content-form">
          <div className="fondo-caja-container">
            <div className="fondo-caja-box">
              <h3 className="fondo-caja-title">Fondo de Caja</h3>
              <div className="fondo-caja-input-container">
                <span className="fondo-caja-currency">$</span>
                <input
                  type="text"
                  className="fondo-caja-input"
                  value={fondoDeCaja}
                  onChange={handleFondoCajaChange}
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="config-form-footer">
              <button
                className="config-btn config-btn-primary"
                onClick={handleGuardarFondoCaja}
                disabled={guardando}
              >
                <FaSave /> {guardando ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      );
    }

    // Contenido específico para Registrar IP y Equipo
    if (vistaActual === 'registrar-ip-equipo') {
      return (
        <div className="config-content-form">
          <div className="registro-ip-container">
            <div className="registro-ip-form">
              <div className="form-group">
                <label className="form-label">Seleccionar Módulo</label>
                <select
                  className="form-select"
                  value={registroIP.modulo}
                  onChange={(e) => setRegistroIP({ ...registroIP, modulo: e.target.value })}
                >
                  <option value="">Seleccione un módulo</option>
                  <option value="Caja Principal">Caja Principal</option>
                  <option value="Mesero 1">Mesero 1</option>
                  <option value="Mesero 2">Mesero 2</option>
                </select>
              </div>

              <div className="modulos-box">
                <h3 className="modulos-title">Módulos</h3>

                <div className="form-group">
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Nombre del equipo (ej: LAPTOPVICTOR)"
                    value={registroIP.nombre}
                    onChange={(e) => setRegistroIP({ ...registroIP, nombre: e.target.value.toUpperCase() })}
                  />
                </div>

                <div className="ip-input-group">
                  {registroIP.ip.map((part, index) => (
                    <React.Fragment key={index}>
                      <input
                        type="text"
                        className="ip-input"
                        value={part}
                        onChange={(e) => handleIPChange(index, e.target.value)}
                        maxLength="3"
                      />
                      {index < 3 && <span className="ip-separator">.</span>}
                    </React.Fragment>
                  ))}
                </div>

                <div className="radio-group">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="tipo"
                      value="caja"
                      checked={registroIP.tipo === 'caja'}
                      onChange={(e) => setRegistroIP({ ...registroIP, tipo: e.target.value })}
                    />
                    <span>Caja</span>
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="tipo"
                      value="mesero"
                      checked={registroIP.tipo === 'mesero'}
                      onChange={(e) => setRegistroIP({ ...registroIP, tipo: e.target.value })}
                    />
                    <span>Mesero</span>
                  </label>
                </div>
              </div>

              <div className="registro-ip-actions">
                <button className="config-btn config-btn-primary" onClick={handleGuardarModulo}>
                  <FaSave /> Guardar
                </button>
                <button className="config-btn config-btn-secondary">
                  <FaPlus /> Nuevo
                </button>
                <button className="config-btn config-btn-danger" onClick={() => setModulosRegistrados([])}>
                  <FaTrash /> Eliminar
                </button>
              </div>
            </div>

            {modulosRegistrados.length > 0 && (
              <div className="modulos-registrados">
                <h3 className="modulos-registrados-title">Módulos Registrados</h3>
                <div className="modulos-list">
                  {modulosRegistrados.map((modulo) => (
                    <div key={modulo.id} className="modulo-item">
                      <div className="modulo-info">
                        <span className="modulo-nombre">{modulo.nombre}</span>
                        <span className="modulo-ip">{modulo.ip}</span>
                        <span className={`modulo-tipo ${modulo.tipo}`}>{modulo.tipo}</span>
                      </div>
                      <button
                        className="modulo-delete"
                        onClick={() => handleEliminarModulo(modulo.id)}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }

    // Contenido específico para Configuración de Email
    if (vistaActual === 'configuracion-email') {
      return (
        <div className="config-content-form">
          <div className="config-form-section">
            <div className="email-config-container">
              <div className="email-info-box">
                <h3 className="email-section-title">Información de las cuentas</h3>

                <div className="email-row">
                  <div className="email-group">
                    <label className="email-label">Sucursal</label>
                    <select
                      className="form-select"
                      value={configEmail.sucursal}
                      onChange={(e) => setConfigEmail({ ...configEmail, sucursal: e.target.value })}
                    >
                      <option value="Norte">Norte</option>
                      <option value="Sur">Sur</option>
                      <option value="Centro">Centro</option>
                    </select>
                  </div>
                </div>

                <div className="email-row">
                  <div className="email-group">
                    <label className="email-label">Cuenta para cortes</label>
                    <input
                      type="email"
                      className="form-input"
                      value={configEmail.cuentaCortes}
                      onChange={(e) => setConfigEmail({ ...configEmail, cuentaCortes: e.target.value })}
                      placeholder="correo@ejemplo.com"
                    />
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={configEmail.enviarEmailCorte}
                        onChange={(e) => setConfigEmail({ ...configEmail, enviarEmailCorte: e.target.checked })}
                      />
                      <span>Enviar email al realizar Corte</span>
                    </label>
                  </div>

                  <div className="email-group">
                    <label className="email-label">Cuenta para críticos</label>
                    <input
                      type="email"
                      className="form-input"
                      value={configEmail.cuentaCriticos}
                      onChange={(e) => setConfigEmail({ ...configEmail, cuentaCriticos: e.target.value })}
                      placeholder="correo@ejemplo.com"
                    />
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={configEmail.enviarCriticosCorte}
                        onChange={(e) => setConfigEmail({ ...configEmail, enviarCriticosCorte: e.target.checked })}
                      />
                      <span>Enviar Críticos al realizar Corte</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="config-form-footer">
            <button
              className="config-btn config-btn-primary"
              onClick={handleGuardarConfigEmail}
              disabled={guardando}
            >
              <FaSave /> {guardando ? 'Guardando...' : 'Guardar'}
            </button>
            <button
              className="config-btn config-btn-secondary"
              onClick={handleEnviarPrueba}
            >
              <FaPaperPlane /> Enviar prueba
            </button>
          </div>
        </div>
      );
    }

    // Contenido específico para Impresión por Platillo
    if (vistaActual === 'impresion-platillo') {
      return (
        <div className="config-content-form">
          <div className="impresion-platillo-container">
            {/* Barra de herramientas */}
            <div className="impresion-toolbar">
              <div className="toolbar-acciones-principal">
                <div className="asignar-group">
                  <select
                    className="form-select impresora-select"
                    value={impresoraAsignar}
                    onChange={(e) => setImpresoraAsignar(e.target.value)}
                  >
                    <option value="">Seleccionar impresora...</option>
                    {impresoras.map(imp => (
                      <option key={imp.id} value={imp.nombre}>
                        {imp.nombre} {imp.isDefault ? '(Predeterminada)' : ''}
                      </option>
                    ))}
                  </select>
                  <button
                    className="config-btn config-btn-primary"
                    onClick={handleAsignarImpresora}
                    disabled={guardando || platillosSeleccionados.length === 0 || !impresoraAsignar}
                  >
                    <FaPrint /> Asignar
                  </button>
                  <button
                    className="config-btn config-btn-danger"
                    onClick={handleQuitarImpresora}
                    disabled={guardando || platillosSeleccionados.length === 0}
                  >
                    <FaTimes /> Quitar
                  </button>
                  <button
                    className="config-btn config-btn-secondary"
                    onClick={limpiarFiltros}
                    disabled={!filtrosColumna.nombre && !filtrosColumna.categoria && !filtrosColumna.impresora && !filtrosColumna.impresoraCategoria}
                    title="Limpiar todos los filtros"
                  >
                    <FaTrash /> Limpiar Filtros
                  </button>
                  <button
                    className="config-btn config-btn-secondary"
                    onClick={cargarDatosImpresionPlatillo}
                    disabled={cargandoPlatillos}
                    title="Refrescar datos"
                  >
                    {cargandoPlatillos ? <FaSpinner className="spin" /> : <FaCogs />}
                  </button>
                </div>
              </div>

              {/* Info de selección y conteo */}
              <div className="toolbar-info">
                <span className="seleccion-count">
                  <strong>{platillosSeleccionados.length}</strong> seleccionados de <strong>{platillosFiltrados.length}</strong> filtrados
                  {platillosFiltrados.length !== platillosImpresora.length && (
                    <span className="total-count"> (Total: {platillosImpresora.length})</span>
                  )}
                </span>
              </div>
            </div>


            {/* Tabla de platillos con filtros tipo Excel */}
            <div className="platillos-table-container">
              {cargandoPlatillos ? (
                <div className="loading-platillos">
                  <FaSpinner className="spin" />
                  <span>Cargando platillos...</span>
                </div>
              ) : (
                <table className="platillos-table">
                  <thead>
                    {/* Fila de títulos */}
                    <tr className="header-titles">
                      <th className="col-check">
                        <button
                          className="check-all-btn"
                          onClick={handleSeleccionarTodos}
                          title={platillosSeleccionados.length === platillosFiltrados.length ? 'Deseleccionar todos' : 'Seleccionar todos'}
                        >
                          {platillosSeleccionados.length === platillosFiltrados.length && platillosFiltrados.length > 0
                            ? <FaCheckSquare />
                            : <FaSquare />
                          }
                        </button>
                      </th>
                      <th className="col-platillo">Platillo</th>
                      <th className="col-categoria">Categoría</th>
                      <th className="col-impresora">Impresora Asignada</th>
                      <th className="col-impresora-cat">Impresora Categoría</th>
                    </tr>
                    {/* Fila de filtros tipo Excel */}
                    <tr className="header-filters">
                      <th className="col-check filter-cell">
                        {/* Vacío para la columna de checkbox */}
                      </th>
                      <th className="col-platillo filter-cell">
                        <input
                          type="text"
                          className="filter-input"
                          placeholder="Filtrar..."
                          value={filtrosColumna.nombre}
                          onChange={(e) => handleFiltroColumnaChange('nombre', e.target.value)}
                        />
                      </th>
                      <th className="col-categoria filter-cell">
                        <select
                          className="filter-select"
                          value={filtrosColumna.categoria}
                          onChange={(e) => handleFiltroColumnaChange('categoria', e.target.value)}
                        >
                          <option value="">Todas</option>
                          {categoriasUnicas.map(cat => (
                            <option key={cat} value={cat}>{cat}</option>
                          ))}
                        </select>
                      </th>
                      <th className="col-impresora filter-cell">
                        <select
                          className="filter-select"
                          value={filtrosColumna.impresora}
                          onChange={(e) => handleFiltroColumnaChange('impresora', e.target.value)}
                        >
                          <option value="">Todas</option>
                          <option value="__sin_asignar__">— Sin asignar —</option>
                          {impresorasUnicas.map(imp => (
                            <option key={imp} value={imp}>{imp}</option>
                          ))}
                        </select>
                      </th>
                      <th className="col-impresora-cat filter-cell">
                        <select
                          className="filter-select"
                          value={filtrosColumna.impresoraCategoria}
                          onChange={(e) => handleFiltroColumnaChange('impresoraCategoria', e.target.value)}
                        >
                          <option value="">Todas</option>
                          {impresorasCatUnicas.map(imp => (
                            <option key={imp} value={imp}>{imp}</option>
                          ))}
                        </select>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {platillosFiltrados.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="no-data">
                          No se encontraron platillos
                        </td>
                      </tr>
                    ) : (
                      platillosFiltrados.map(platillo => (
                        <tr
                          key={platillo.idPlatillo}
                          className={platillosSeleccionados.includes(platillo.idPlatillo) ? 'selected' : ''}
                          onClick={() => handleSeleccionarPlatillo(platillo.idPlatillo)}
                        >
                          <td className="col-check">
                            <span className="check-icon">
                              {platillosSeleccionados.includes(platillo.idPlatillo)
                                ? <FaCheckSquare className="checked" />
                                : <FaSquare />
                              }
                            </span>
                          </td>
                          <td className="col-platillo">{platillo.nombre}</td>
                          <td className="col-categoria">
                            <span className="categoria-badge">{platillo.nombreCategoria}</span>
                          </td>
                          <td className="col-impresora">
                            {platillo.impresora ? (
                              <span className="impresora-badge asignada">
                                <FaPrint /> {platillo.impresora}
                              </span>
                            ) : (
                              <span className="impresora-badge sin-asignar">Sin asignar</span>
                            )}
                          </td>
                          <td className="col-impresora-cat">
                            {platillo.impresoraCategoria ? (
                              <span className="impresora-badge categoria">
                                {platillo.impresoraCategoria}
                              </span>
                            ) : (
                              <span className="impresora-badge sin-asignar">-</span>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>

            {/* Leyenda */}
            <div className="impresion-leyenda">
              <h4>Información:</h4>
              <ul>
                <li><strong>Impresora Asignada:</strong> Impresora configurada directamente para el platillo.</li>
                <li><strong>Impresora Categoría:</strong> Impresora heredada de la categoría (se usa si el platillo no tiene impresora asignada).</li>
                <li>Selecciona uno o más platillos y asigna una impresora para configurar dónde se imprimirán las comandas.</li>
              </ul>
            </div>
          </div>
        </div>
      );
    }

    // Contenido específico para Configuración del Biométrico
    if (vistaActual === 'configuracion-biometrico') {
      return (
        <div className="config-content-form">
          <div className="config-form-section">
            <div className="biometrico-config-container">
            <div className="biometrico-info-box">
              <h3 className="biometrico-section-title">
                <FaFingerprint /> Dispositivo Biométrico ZKTeco
              </h3>

              <div className="biometrico-form-group">
                <label className="biometrico-label">Nombre del Dispositivo</label>
                <input
                  type="text"
                  className="form-input"
                  value={configBiometrico.nombreDispositivo}
                  onChange={(e) => setConfigBiometrico({ ...configBiometrico, nombreDispositivo: e.target.value })}
                  placeholder="Ej: Entrada Principal, Cocina, Almacén..."
                />
                <span className="input-hint">Identificador para reconocer este dispositivo</span>
              </div>

              <div className="biometrico-device-info">
                <div className="device-model">
                  <span className="device-label">Modelo:</span>
                  <select
                    className="form-select modelo-select"
                    value={configBiometrico.modelo}
                    onChange={(e) => setConfigBiometrico({ ...configBiometrico, modelo: e.target.value })}
                  >
                    <option value="MB160">ZKTeco MB160</option>
                    <option value="MB360">ZKTeco MB360</option>
                    <option value="MB460">ZKTeco MB460</option>
                    <option value="MB560">ZKTeco MB560</option>
                    <option value="K40">ZKTeco K40</option>
                    <option value="K50">ZKTeco K50</option>
                    <option value="Otro">Otro modelo ZKTeco</option>
                  </select>
                </div>
                <div className={`connection-status ${estadoConexion || ''}`}>
                  {estadoConexion === 'success' && <><FaCheck /> Conectado</>}
                  {estadoConexion === 'error' && <><FaTimes /> Sin conexión</>}
                  {!estadoConexion && <><FaNetworkWired /> Sin probar</>}
                </div>
              </div>

              <div className="biometrico-form-group">
                <label className="biometrico-label">Dirección IP del dispositivo</label>
                <div className="ip-input-group">
                  {configBiometrico.ip.map((part, index) => (
                    <React.Fragment key={index}>
                      <input
                        type="text"
                        className="ip-input"
                        value={part}
                        onChange={(e) => handleBiometricoIPChange(index, e.target.value)}
                        maxLength="3"
                        placeholder="0"
                      />
                      {index < 3 && <span className="ip-separator">.</span>}
                    </React.Fragment>
                  ))}
                </div>
              </div>

              <div className="biometrico-row">
                <div className="biometrico-form-group">
                  <label className="biometrico-label">Puerto</label>
                  <input
                    type="text"
                    className="form-input"
                    value={configBiometrico.puerto}
                    onChange={(e) => {
                      if (/^\d{0,5}$/.test(e.target.value)) {
                        setConfigBiometrico({ ...configBiometrico, puerto: e.target.value });
                        setEstadoConexion(null);
                      }
                    }}
                    placeholder="4370"
                  />
                  <span className="input-hint">Puerto estándar ZKTeco: 4370</span>
                </div>

                <div className="biometrico-form-group">
                  <label className="biometrico-label">Timeout (ms)</label>
                  <select
                    className="form-select"
                    value={configBiometrico.timeout}
                    onChange={(e) => setConfigBiometrico({ ...configBiometrico, timeout: e.target.value })}
                  >
                    <option value="5000">5 segundos</option>
                    <option value="10000">10 segundos</option>
                    <option value="15000">15 segundos</option>
                    <option value="30000">30 segundos</option>
                  </select>
                  <span className="input-hint">Tiempo de espera para conexión</span>
                </div>
              </div>

              <div className="biometrico-form-group">
                <label className="checkbox-label biometrico-checkbox">
                  <input
                    type="checkbox"
                    checked={configBiometrico.autoConectar}
                    onChange={(e) => setConfigBiometrico({ ...configBiometrico, autoConectar: e.target.checked })}
                  />
                  <span>Conectar automáticamente al abrir el módulo de biométrico</span>
                </label>
              </div>

              {/* Sección: Configuración del Servidor de Base de Datos */}
              <div className="biometrico-section-divider">
                <div className="biometrico-section-header-row">
                  <h4 className="biometrico-section-title">
                    <FaDatabase /> Conexión al Servidor de Base de Datos
                  </h4>
                  <div className="biometrico-section-header-actions">
                    <div className={`connection-status ${estadoConexionDB || ''}`}>
                      {estadoConexionDB === 'success' && <><FaCheck /> Conectado</>}
                      {estadoConexionDB === 'error' && <><FaTimes /> Sin conexión</>}
                      {!estadoConexionDB && <><FaNetworkWired /> Sin probar</>}
                    </div>
                    <button
                      type="button"
                      className="config-btn config-btn-secondary biometrico-btn-test-db"
                      onClick={handleProbarConexionDB}
                      disabled={probandoConexionDB}
                    >
                      {probandoConexionDB ? (
                        <><FaSpinner className="spin" /> Probando...</>
                      ) : (
                        <><FaPlug /> Probar Conexión</>
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="biometrico-form-row">
                <div className="biometrico-form-group">
                  <label className="biometrico-label">Servidor / Host</label>
                  <input
                    type="text"
                    className="form-input"
                    value={configBiometrico.servidorDB}
                    onChange={(e) => { setConfigBiometrico({ ...configBiometrico, servidorDB: e.target.value }); setEstadoConexionDB(null); }}
                    placeholder="Ej: 192.168.1.100 o localhost"
                  />
                  <span className="input-hint">Dirección IP o nombre del servidor MySQL</span>
                </div>
                <div className="biometrico-form-group">
                  <label className="biometrico-label">Base de Datos</label>
                  <input
                    type="text"
                    className="form-input"
                    value={configBiometrico.baseDatos}
                    onChange={(e) => { setConfigBiometrico({ ...configBiometrico, baseDatos: e.target.value }); setEstadoConexionDB(null); }}
                    placeholder="Ej: presto_db"
                  />
                  <span className="input-hint">Nombre de la base de datos</span>
                </div>
              </div>

              <div className="biometrico-form-row">
                <div className="biometrico-form-group">
                  <label className="biometrico-label">Usuario</label>
                  <input
                    type="text"
                    className="form-input"
                    value={configBiometrico.usuarioDB}
                    onChange={(e) => { setConfigBiometrico({ ...configBiometrico, usuarioDB: e.target.value }); setEstadoConexionDB(null); }}
                    placeholder="Ej: root"
                  />
                  <span className="input-hint">Usuario de MySQL</span>
                </div>
                <div className="biometrico-form-group">
                  <label className="biometrico-label">Contraseña</label>
                  <input
                    type="password"
                    className="form-input"
                    value={configBiometrico.passwordDB}
                    onChange={(e) => { setConfigBiometrico({ ...configBiometrico, passwordDB: e.target.value }); setEstadoConexionDB(null); }}
                    placeholder="••••••••"
                  />
                  <span className="input-hint">Contraseña de MySQL</span>
                </div>
              </div>

              {/* Sección: Configuración de Tablas */}
              <div className="biometrico-section-divider">
                <h4 className="biometrico-section-title">
                  <FaTable /> Configuración de Tablas
                </h4>
              </div>

              <div className="biometrico-form-row">
                <div className="biometrico-form-group">
                  <label className="biometrico-label">Tabla para Registros de Asistencia</label>
                  <input
                    type="text"
                    className="form-input"
                    value={configBiometrico.tablaRegistros}
                    onChange={(e) => setConfigBiometrico({ ...configBiometrico, tablaRegistros: e.target.value })}
                    placeholder="Ej: checadas"
                  />
                  <span className="input-hint">Tabla donde se guardarán los registros de entrada/salida</span>
                </div>
                <div className="biometrico-form-group">
                  <label className="biometrico-label">Tabla para Huellas Digitales</label>
                  <input
                    type="text"
                    className="form-input"
                    value={configBiometrico.tablaHuellas}
                    onChange={(e) => setConfigBiometrico({ ...configBiometrico, tablaHuellas: e.target.value })}
                    placeholder="Ej: huellas_digitales"
                  />
                  <span className="input-hint">Tabla donde se sincronizarán las huellas del dispositivo</span>
                </div>
              </div>

              {/* Sección: Ruta de XAMPP */}
              <div className="biometrico-section-divider">
                <h4 className="biometrico-section-title">
                  <FaFolder /> Ruta de XAMPP
                </h4>
              </div>

              <div className="biometrico-form-group">
                <label className="biometrico-label">Ruta de instalación de XAMPP</label>
                <input
                  type="text"
                  className="form-input"
                  value={configBiometrico.rutaXampp}
                  onChange={(e) => { setConfigBiometrico({ ...configBiometrico, rutaXampp: e.target.value }); setEstadoConexionDB(null); }}
                  placeholder="Ej: C:\xampp"
                />
                <span className="input-hint">Ruta donde está instalado XAMPP (se usará para acceder a mysql.exe)</span>
              </div>

              <div className="biometrico-help">
                <h4>Instrucciones de configuración:</h4>
                <ul>
                  <li>Seleccione el modelo de su dispositivo ZKTeco (MB160, MB360, MB460, etc.).</li>
                  <li>Asegúrese de que el dispositivo esté encendido y conectado a la red.</li>
                  <li>Verifique la dirección IP del dispositivo en el menú del equipo (Menú → Comunicación → TCP/IP).</li>
                  <li>El puerto estándar de comunicación es 4370 para todos los modelos ZKTeco.</li>
                  <li>Use el botón "Probar Conexión" para verificar la comunicación antes de guardar.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="config-form-footer">
          <button
            className="config-btn config-btn-secondary"
            onClick={handleProbarConexionBiometrico}
            disabled={probandoConexion || guardando}
          >
            {probandoConexion ? (
              <><FaSpinner className="spin" /> Probando...</>
            ) : (
              <><FaPlug /> Probar Conexión</>
            )}
          </button>
          <button
            className="config-btn config-btn-primary"
            onClick={handleGuardarBiometrico}
            disabled={guardando || probandoConexion}
          >
            <FaSave /> {guardando ? 'Guardando...' : 'Guardar Configuración'}
          </button>
        </div>
        </div>
      );
    }

    // Contenido específico para Configuración de Licencia
    if (vistaActual === 'configuracion-licencia') {
      return (
        <div className="config-content-form">
          <div className="config-form-section">
          <div className="biometrico-config-container">
            <div className="biometrico-info-box">
              <h3 className="biometrico-section-title">
                <FaShieldAlt /> Licencia del Sistema
              </h3>

              {/* Estado actual de la licencia */}
              {estadoLicencia && (
                <div className={`licencia-status-box ${new Date(estadoLicencia.fecha_expiracion) > new Date() ? 'licencia-activa' : 'licencia-vencida'}`}>
                  <div className="licencia-status-header">
                    <span className={`licencia-badge ${new Date(estadoLicencia.fecha_expiracion) > new Date() ? 'badge-activa' : 'badge-vencida'}`}>
                      {new Date(estadoLicencia.fecha_expiracion) > new Date() ? 'ACTIVA' : 'VENCIDA'}
                    </span>
                    <span className="licencia-tipo">{estadoLicencia.tipo?.toUpperCase()}</span>
                  </div>
                  <div className="licencia-status-details">
                    <div className="licencia-detail-item">
                      <FaUser /> <strong>Cliente:</strong> {estadoLicencia.cliente_nombre}
                    </div>
                    <div className="licencia-detail-item">
                      <FaCalendarAlt /> <strong>Expira:</strong> {estadoLicencia.fecha_expiracion}
                    </div>
                    <div className="licencia-detail-item">
                      <FaDesktop /> <strong>Dispositivo:</strong> {nombrePC}
                    </div>
                    <div className="licencia-detail-item">
                      <FaCheck /> <strong>Verificado:</strong> {estadoLicencia.verificado_en}
                    </div>
                  </div>
                </div>
              )}

              {!estadoLicencia && (
                <div className="licencia-status-box licencia-sin-activar">
                  <p>No hay licencia activada en este dispositivo</p>
                </div>
              )}

              {/* Configuración del servidor */}
              <div className="biometrico-section-divider">
                <h4 className="biometrico-section-title">
                  <FaNetworkWired /> Servidor de Licencias
                </h4>
              </div>

              <div className="biometrico-form-group">
                <label className="biometrico-label">URL del Servidor (API)</label>
                <input
                  type="text"
                  className="form-input"
                  value={configLicencia.urlServidor}
                  onChange={(e) => setConfigLicencia({ ...configLicencia, urlServidor: e.target.value })}
                  placeholder="Ej: http://IP_SERVIDOR/api_prestov2/reportes/funciones_php/api.php"
                />
                <span className="input-hint">URL de la API local (XAMPP) o remota (CPanel)</span>
              </div>

              {/* Clave de licencia */}
              <div className="biometrico-section-divider">
                <h4 className="biometrico-section-title">
                  <FaLicencia /> Clave de Licencia
                </h4>
              </div>

              <div className="biometrico-form-group">
                <label className="biometrico-label">Clave de Licencia</label>
                <input
                  type="text"
                  className="form-input"
                  value={configLicencia.claveLicencia}
                  onChange={(e) => setConfigLicencia({ ...configLicencia, claveLicencia: e.target.value.toUpperCase() })}
                  placeholder="Ej: PRESTO-XXXX-XXXX-XXXX"
                  style={{ fontFamily: 'monospace', letterSpacing: '1px' }}
                />
              </div>

              {/* Info del dispositivo */}
              <div className="biometrico-section-divider">
                <h4 className="biometrico-section-title">
                  <FaDesktop /> Información del Dispositivo
                </h4>
              </div>

              <div className="biometrico-form-row">
                <div className="biometrico-form-group">
                  <label className="biometrico-label">Nombre del equipo</label>
                  <input type="text" className="form-input" value={nombrePC} disabled />
                </div>
                <div className="biometrico-form-group">
                  <label className="biometrico-label">ID del dispositivo</label>
                  <input type="text" className="form-input" value={machineId} disabled style={{ fontFamily: 'monospace', fontSize: '12px' }} />
                </div>
              </div>

              <div className="biometrico-help">
                <h4>Instrucciones:</h4>
                <ul>
                  <li>Ingrese la URL de la API (local o remota) donde se validan las licencias.</li>
                  <li>Ingrese la clave de licencia proporcionada por el administrador.</li>
                  <li>Presione "Activar Licencia" para vincular este dispositivo.</li>
                  <li>La licencia se verifica automáticamente cada vez que se abre la aplicación.</li>
                  <li>Si no hay conexión a internet, la app funcionará hasta 7 días con la última verificación.</li>
                </ul>
              </div>
            </div>
          </div>
          </div>
          <div className="config-form-footer">
            {!estadoLicencia ? (
              <button
                className="config-btn config-btn-primary"
                onClick={handleActivarLicencia}
                disabled={procesandoLicencia}
              >
                {procesandoLicencia ? (
                  <><FaSpinner className="spin" /> Activando...</>
                ) : (
                  <><FaShieldAlt /> Activar Licencia</>
                )}
              </button>
            ) : (
              <>
                <button
                  className="config-btn config-btn-secondary"
                  onClick={handleVerificarLicencia}
                  disabled={procesandoLicencia}
                >
                  {procesandoLicencia ? (
                    <><FaSpinner className="spin" /> Verificando...</>
                  ) : (
                    <><FaCheck /> Verificar Ahora</>
                  )}
                </button>
                <button
                  className="config-btn config-btn-primary"
                  onClick={handleGuardarConfigLicencia}
                  disabled={procesandoLicencia}
                >
                  <FaSave /> Guardar Configuración
                </button>
                <button
                  className="config-btn"
                  onClick={handleDesactivarLicencia}
                  disabled={procesandoLicencia}
                  style={{ backgroundColor: '#dc3545', color: 'white' }}
                >
                  <FaUnlink /> Desactivar
                </button>
              </>
            )}
          </div>
        </div>
      );
    }

    // Contenido específico para Configuración de Actualizaciones
    if (vistaActual === 'configuracion-actualizaciones') {
      return (
        <div className="config-content-form">
          <div className="biometrico-config-container">
            <div className="biometrico-info-box">
              <h3 className="biometrico-section-title">
                <FaCogs /> Actualizaciones del Sistema
              </h3>

              {/* Versión actual */}
              <div className="licencia-status-box licencia-activa" style={{ textAlign: 'center' }}>
                <strong>Version actual:</strong> {appVersion || 'No disponible (modo navegador)'}
              </div>

              {/* URL del servidor de actualizaciones */}
              <div className="biometrico-section-divider">
                <h4 className="biometrico-section-title">
                  <FaNetworkWired /> Servidor de Actualizaciones
                </h4>
              </div>

              <div className="biometrico-form-group">
                <label className="biometrico-label">URL del servidor de actualizaciones</label>
                <input
                  type="text"
                  className="form-input"
                  value={updaterUrl}
                  onChange={(e) => setUpdaterUrl(e.target.value)}
                  placeholder="http://192.168.1.83/api_prestov2/update"
                />
                <span className="input-hint">Carpeta en el servidor donde se suben los archivos de actualización (latest.yml + instalador)</span>
              </div>

              {/* Resultado de búsqueda */}
              {updateResult && (
                <div className={`licencia-status-box ${updateResult.type === 'error' ? 'licencia-vencida' : updateResult.type === 'success' ? 'licencia-activa' : 'licencia-sin-activar'}`}>
                  <p style={{ margin: 0 }}>{updateResult.message}</p>
                  {updateProgress !== null && updateProgress < 100 && (
                    <div style={{ marginTop: 10, background: '#e0e0e0', borderRadius: 6, overflow: 'hidden', height: 18 }}>
                      <div style={{
                        width: `${updateProgress}%`,
                        background: 'linear-gradient(90deg, #2563eb, #059669)',
                        height: '100%',
                        borderRadius: 6,
                        transition: 'width 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: 11,
                        fontWeight: 600
                      }}>
                        {updateProgress}%
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Botones */}
              <div className="biometrico-actions">
                <button
                  className="config-btn config-btn-secondary"
                  onClick={handleBuscarActualizaciones}
                  disabled={buscandoUpdate}
                >
                  {buscandoUpdate ? (
                    <><FaSpinner className="spin" /> Buscando...</>
                  ) : (
                    <><FaSearch /> Buscar Actualizaciones</>
                  )}
                </button>
                <button
                  className="config-btn config-btn-primary"
                  onClick={handleGuardarUpdaterUrl}
                >
                  <FaSave /> Guardar URL
                </button>
              </div>

              <div className="biometrico-help">
                <h4>Instrucciones:</h4>
                <ul>
                  <li>Configure la URL del servidor donde se alojan las actualizaciones.</li>
                  <li>Al hacer build, suba los archivos <code>latest.yml</code> y el instalador <code>.exe</code> a esa carpeta.</li>
                  <li>La app verifica automaticamente al iniciar si hay una nueva version.</li>
                  <li>Si hay actualizacion, se descarga e instala automaticamente antes de permitir el uso.</li>
                </ul>
              </div>

              {/* ===== SECCIÓN DE REPLICACIÓN DE BASE DE DATOS ===== */}
              <div style={{ borderTop: '2px solid #e0e0e0', marginTop: '24px', paddingTop: '20px' }}>
                <h3 className="biometrico-section-title">
                  <FaDatabase /> Replicación de Base de Datos
                </h3>
                <p style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
                  Replique la base de datos local hacia un servidor remoto. Esto copiará las tablas seleccionadas al servidor destino.
                </p>

                {/* Base de datos local */}
                <div className="biometrico-section-divider">
                  <h4 className="biometrico-section-title">
                    <FaDesktop /> Base de Datos Local (Origen)
                  </h4>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                  <div className="biometrico-form-group" style={{ marginBottom: 0 }}>
                    <label className="biometrico-label">Servidor</label>
                    <input
                      type="text"
                      className="form-input"
                      value={configReplicacion.localServidor}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, localServidor: e.target.value })}
                      placeholder="localhost"
                    />
                  </div>
                  <div className="biometrico-form-group" style={{ marginBottom: 0 }}>
                    <label className="biometrico-label">Base de Datos</label>
                    <input
                      type="text"
                      className="form-input"
                      value={configReplicacion.localBaseDatos}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, localBaseDatos: e.target.value })}
                      placeholder="kapital_restaurant_base1"
                    />
                  </div>
                  <div className="biometrico-form-group" style={{ marginBottom: 0 }}>
                    <label className="biometrico-label">Usuario</label>
                    <input
                      type="text"
                      className="form-input"
                      value={configReplicacion.localUsuario}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, localUsuario: e.target.value })}
                      placeholder="root"
                    />
                  </div>
                  <div className="biometrico-form-group" style={{ marginBottom: 0 }}>
                    <label className="biometrico-label">Contraseña</label>
                    <input
                      type="password"
                      className="form-input"
                      value={configReplicacion.localPassword}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, localPassword: e.target.value })}
                      placeholder="(vacío)"
                    />
                  </div>
                </div>

                <div className="biometrico-form-group">
                  <label className="biometrico-label">Ruta de XAMPP</label>
                  <input
                    type="text"
                    className="form-input"
                    value={configReplicacion.rutaXampp}
                    onChange={(e) => setConfigReplicacion({ ...configReplicacion, rutaXampp: e.target.value })}
                    placeholder="C:\xampp"
                  />
                  <span className="input-hint">Ruta donde está instalado XAMPP (se usa mysqldump.exe para exportar)</span>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <button
                    className="config-btn config-btn-secondary"
                    onClick={handleCargarTablas}
                    disabled={cargandoTablas}
                  >
                    {cargandoTablas ? <><FaSpinner className="spin" /> Cargando...</> : <><FaDatabase /> Cargar Tablas</>}
                  </button>
                </div>

                {/* Selección de tablas */}
                {tablasDisponibles.length > 0 && (
                  <div style={{ marginBottom: '16px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                      <label className="biometrico-label" style={{ marginBottom: 0 }}>
                        Tablas a replicar ({tablasSeleccionadas.length}/{tablasDisponibles.length})
                      </label>
                      <button
                        onClick={handleSeleccionarTodas}
                        style={{
                          background: 'none', border: '1px solid #ccc', borderRadius: '4px',
                          padding: '3px 10px', fontSize: '11px', cursor: 'pointer', color: '#555'
                        }}
                      >
                        {tablasSeleccionadas.length === tablasDisponibles.length ? 'Deseleccionar todas' : 'Seleccionar todas'}
                      </button>
                    </div>
                    <div style={{
                      maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd',
                      borderRadius: '6px', padding: '6px', background: '#fafafa',
                      display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '2px'
                    }}>
                      {tablasDisponibles.map(tabla => (
                        <label key={tabla} style={{
                          display: 'flex', alignItems: 'center', gap: '6px',
                          padding: '4px 8px', fontSize: '11px', cursor: 'pointer',
                          borderRadius: '3px', background: tablasSeleccionadas.includes(tabla) ? '#e3f2fd' : 'transparent'
                        }}>
                          <input
                            type="checkbox"
                            checked={tablasSeleccionadas.includes(tabla)}
                            onChange={() => handleToggleTabla(tabla)}
                          />
                          {tabla}
                        </label>
                      ))}
                    </div>
                  </div>
                )}

                {/* Base de datos remota */}
                <div className="biometrico-section-divider">
                  <h4 className="biometrico-section-title">
                    <FaNetworkWired /> Servidor Remoto (Destino)
                  </h4>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                  <div className="biometrico-form-group" style={{ marginBottom: 0 }}>
                    <label className="biometrico-label">Servidor / IP</label>
                    <input
                      type="text"
                      className="form-input"
                      value={configReplicacion.remotoServidor}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, remotoServidor: e.target.value })}
                      placeholder="192.168.1.100"
                    />
                  </div>
                  <div className="biometrico-form-group" style={{ marginBottom: 0 }}>
                    <label className="biometrico-label">Puerto</label>
                    <input
                      type="text"
                      className="form-input"
                      value={configReplicacion.remotoPuerto}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, remotoPuerto: e.target.value })}
                      placeholder="3306"
                    />
                  </div>
                  <div className="biometrico-form-group" style={{ marginBottom: 0 }}>
                    <label className="biometrico-label">Base de Datos</label>
                    <input
                      type="text"
                      className="form-input"
                      value={configReplicacion.remotoBaseDatos}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, remotoBaseDatos: e.target.value })}
                      placeholder="nombre_base_datos"
                    />
                  </div>
                  <div className="biometrico-form-group" style={{ marginBottom: 0 }}>
                    <label className="biometrico-label">Usuario</label>
                    <input
                      type="text"
                      className="form-input"
                      value={configReplicacion.remotoUsuario}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, remotoUsuario: e.target.value })}
                      placeholder="usuario"
                    />
                  </div>
                  <div className="biometrico-form-group" style={{ marginBottom: 0, gridColumn: 'span 2' }}>
                    <label className="biometrico-label">Contraseña</label>
                    <input
                      type="password"
                      className="form-input"
                      value={configReplicacion.remotoPassword}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, remotoPassword: e.target.value })}
                      placeholder="contraseña"
                    />
                  </div>
                </div>

                {/* Estado conexión remota */}
                {estadoRemoto && (
                  <div className={`licencia-status-box ${estadoRemoto === 'success' ? 'licencia-activa' : 'licencia-vencida'}`} style={{ marginBottom: '12px' }}>
                    <p style={{ margin: 0 }}>
                      {estadoRemoto === 'success' ? 'Conexión exitosa al servidor remoto' : 'No se pudo conectar al servidor remoto'}
                    </p>
                  </div>
                )}

                {/* Progreso de replicación */}
                {replicando && progresoReplicacion && (
                  <div className="licencia-status-box licencia-sin-activar" style={{ marginBottom: '12px' }}>
                    <p style={{ margin: 0, marginBottom: '8px' }}>{progresoReplicacion.mensaje}</p>
                    <div style={{ background: '#e0e0e0', borderRadius: 6, overflow: 'hidden', height: 18 }}>
                      <div style={{
                        width: `${progresoReplicacion.porcentaje || 0}%`,
                        background: 'linear-gradient(90deg, #2563eb, #059669)',
                        height: '100%', borderRadius: 6, transition: 'width 0.3s ease',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#fff', fontSize: 11, fontWeight: 600
                      }}>
                        {progresoReplicacion.porcentaje || 0}%
                      </div>
                    </div>
                  </div>
                )}

                {/* Resultado de replicación */}
                {resultadoReplicacion && !replicando && (
                  <div className={`licencia-status-box ${resultadoReplicacion.success ? 'licencia-activa' : 'licencia-vencida'}`} style={{ marginBottom: '12px' }}>
                    <p style={{ margin: 0 }}>{resultadoReplicacion.message}</p>
                    {resultadoReplicacion.errores && resultadoReplicacion.errores.length > 0 && (
                      <div style={{ marginTop: '8px', fontSize: '11px' }}>
                        <strong>Errores:</strong>
                        <ul style={{ margin: '4px 0', paddingLeft: '20px' }}>
                          {resultadoReplicacion.errores.map((e, i) => (
                            <li key={i}><strong>{e.tabla}:</strong> {e.error}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}

                {/* Replicación Automática */}
                <div className="biometrico-section-divider">
                  <h4 className="biometrico-section-title">
                    <FaCogs /> Replicación Automática
                  </h4>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '12px', flexWrap: 'wrap' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      checked={configReplicacion.autoReplicar === 1 || configReplicacion.autoReplicar === '1'}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, autoReplicar: e.target.checked ? 1 : 0 })}
                      style={{ width: '18px', height: '18px' }}
                    />
                    <strong>Activar replicación automática</strong>
                  </label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
                    <label>Intervalo (segundos):</label>
                    <input
                      type="number"
                      min="5"
                      max="3600"
                      value={configReplicacion.intervaloSegundos || 10}
                      onChange={(e) => setConfigReplicacion({ ...configReplicacion, intervaloSegundos: e.target.value })}
                      style={{ width: '70px', padding: '4px 8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '12px' }}
                    />
                  </div>
                </div>

                {/* Estado del servicio automático */}
                <div style={{
                  display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 14px',
                  borderRadius: '6px', fontSize: '12px', marginBottom: '12px',
                  background: autoReplicarActivo ? '#e8f5e9' : '#f5f5f5',
                  border: `1px solid ${autoReplicarActivo ? '#a5d6a7' : '#e0e0e0'}`
                }}>
                  <div style={{
                    width: '10px', height: '10px', borderRadius: '50%',
                    background: autoReplicarActivo ? '#4CAF50' : '#999',
                    boxShadow: autoReplicarActivo ? '0 0 6px #4CAF50' : 'none'
                  }} />
                  <span>
                    <strong>Estado:</strong> {autoReplicarActivo ? 'Servicio activo' : 'Servicio detenido'}
                  </span>
                  {ultimaReplicacionAuto && (
                    <span style={{ marginLeft: 'auto', color: ultimaReplicacionAuto.success ? '#2e7d32' : '#c62828' }}>
                      Última: {ultimaReplicacionAuto.timestamp} — {ultimaReplicacionAuto.exitosas} ok, {ultimaReplicacionAuto.errores} errores
                    </span>
                  )}
                </div>

                <span className="input-hint" style={{ display: 'block', marginBottom: '16px' }}>
                  Al guardar la configuración con la bandera activa, el servicio se inicia automáticamente. También arranca al abrir la aplicación si la bandera está en 1.
                </span>

                {/* Botones de acción */}
                <div className="biometrico-actions">
                  <button
                    className="config-btn config-btn-secondary"
                    onClick={handleProbarConexionRemota}
                    disabled={probandoRemoto || replicando}
                  >
                    {probandoRemoto ? <><FaSpinner className="spin" /> Probando...</> : <><FaPlug /> Probar Conexión Remota</>}
                  </button>
                  <button
                    className="config-btn config-btn-primary"
                    onClick={handleGuardarConfigReplicacion}
                    disabled={replicando}
                  >
                    <FaSave /> Guardar Configuración
                  </button>
                  <button
                    className="config-btn"
                    style={{ background: replicando ? '#999' : 'linear-gradient(135deg, #e65100, #f57c00)', color: 'white', border: 'none' }}
                    onClick={handleReplicar}
                    disabled={replicando || tablasSeleccionadas.length === 0}
                  >
                    {replicando ? <><FaSpinner className="spin" /> Replicando...</> : <><FaDatabase /> Iniciar Replicación</>}
                  </button>
                </div>

                <div className="biometrico-help" style={{ marginTop: '16px' }}>
                  <h4>Instrucciones de Replicación:</h4>
                  <ul>
                    <li>Configure los datos de conexión de la base de datos <strong>local</strong> (origen) y del <strong>servidor remoto</strong> (destino).</li>
                    <li>Haga click en <strong>"Cargar Tablas"</strong> para ver las tablas disponibles en la base local.</li>
                    <li>Seleccione las tablas que desea replicar.</li>
                    <li>Use <strong>"Probar Conexión Remota"</strong> para verificar que el servidor destino es accesible.</li>
                    <li>Haga click en <strong>"Iniciar Replicación"</strong> para copiar las tablas seleccionadas al servidor remoto.</li>
                    <li>Active la <strong>replicación automática</strong> para que se ejecute cada X segundos sin intervención.</li>
                    <li>El servicio arranca automáticamente al abrir la app si la bandera está activada.</li>
                    <li><strong>Importante:</strong> Las tablas en el servidor remoto serán reemplazadas completamente (DROP + CREATE + INSERT).</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      );
    }

    // === VISTAS DE TICKETS ===

    // 1. Orden de Productos Reportes
    if (vistaActual === 'orden-productos-reportes') {
      return (
        <div className="config-content-form">
          <div className="config-form-section">
            <div className="config-group">
              <h3 className="config-group-title">Ordenar productos por</h3>
              {[
                { value: 'categoria', label: 'Categoría' },
                { value: 'nombre', label: 'Nombre del producto' },
                { value: 'precio', label: 'Precio' },
                { value: 'id', label: 'Orden de registro (ID)' }
              ].map(opt => (
                <div className="config-item" key={opt.value}>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="ordenProductos"
                      value={opt.value}
                      checked={ordenProductos.criterio === opt.value}
                      onChange={(e) => setOrdenProductos({ ...ordenProductos, criterio: e.target.value })}
                    />
                    <span>{opt.label}</span>
                  </label>
                </div>
              ))}
            </div>

            <div className="config-group">
              <h3 className="config-group-title">Opciones</h3>
              <div className="config-item">
                <label className="config-checkbox">
                  <input
                    type="checkbox"
                    checked={ordenProductos.agruparPorCategoria}
                    onChange={() => setOrdenProductos(prev => ({ ...prev, agruparPorCategoria: !prev.agruparPorCategoria }))}
                  />
                  <span className="config-checkmark">
                    {ordenProductos.agruparPorCategoria && <FaCheck />}
                  </span>
                  <span className="config-label">Agrupar productos por categoría</span>
                </label>
              </div>
              <div className="config-item" style={{ marginTop: 10 }}>
                <label className="config-checkbox">
                  <input
                    type="checkbox"
                    checked={ordenProductos.ordenAscendente}
                    onChange={() => setOrdenProductos(prev => ({ ...prev, ordenAscendente: !prev.ordenAscendente }))}
                  />
                  <span className="config-checkmark">
                    {ordenProductos.ordenAscendente && <FaCheck />}
                  </span>
                  <span className="config-label">Orden ascendente (A-Z / menor a mayor)</span>
                </label>
              </div>
            </div>
          </div>

          <div className="config-form-footer">
            <button className="config-btn config-btn-primary" onClick={handleGuardarOrdenProductos} disabled={guardando}>
              <FaSave /> {guardando ? 'Guardando...' : 'Guardar Configuración'}
            </button>
          </div>
        </div>
      );
    }

    // 2. Encabezado Ticket Cuenta
    if (vistaActual === 'encabezado-ticket-cuenta') {
      const camposConfig = [
        { key: 'nombre_negocio', label: 'Nombre del negocio', placeholder: 'Ej: KAPITAL SUSHI' },
        { key: 'nombre_sucursal', label: 'Sucursal', placeholder: 'Ej: BONATERRA' },
        { key: 'direccion_linea1', label: 'Dirección línea 1', placeholder: 'Ej: AV. JOSE MARIA CHAVEZ #2303' },
        { key: 'direccion_linea2', label: 'Dirección línea 2', placeholder: 'Ej: COL. SAN FRANCISCO DEL ARENAL' },
        { key: 'razon_social', label: 'Razón social', placeholder: 'Ej: OPERADORA ASR S.A DE C.V.' },
        { key: 'rfc', label: 'RFC', placeholder: 'Ej: OAC1404108V8' },
        { key: 'telefono', label: 'Teléfono', placeholder: 'Ej: 449-123-4567' }
      ];

      return (
        <div className="config-content-form">
          {cargandoInfoNegocio ? (
            <div className="loading-platillos"><FaSpinner className="spin" /><span>Cargando...</span></div>
          ) : (
            <div className="ticket-config-layout">
              <div className="ticket-preview-section">
                <h3 className="config-group-title">Vista previa del encabezado</h3>
                <div className="ticket-preview">
                  {logoEnabled && ticketLogo && (
                    <div style={{ width: '100%', textAlign: 'center', marginBottom: 8 }}>
                      <img src={ticketLogo} alt="Logo" style={{ maxWidth: '50%', height: 'auto', display: 'block', margin: '0 auto' }} />
                    </div>
                  )}
                  {camposEncabezadoCuenta.nombre_negocio && <div className="preview-line bold">{infoNegocio.nombre_negocio || 'NOMBRE DEL NEGOCIO'}</div>}
                  {camposEncabezadoCuenta.nombre_sucursal && <div className="preview-line">{infoNegocio.nombre_sucursal || 'SUCURSAL'}</div>}
                  {camposEncabezadoCuenta.direccion_linea1 && <div className="preview-line small">{infoNegocio.direccion_linea1 || 'Dirección línea 1'}</div>}
                  {camposEncabezadoCuenta.direccion_linea2 && <div className="preview-line small">{infoNegocio.direccion_linea2 || 'Dirección línea 2'}</div>}
                  {camposEncabezadoCuenta.razon_social && <div className="preview-line small">{infoNegocio.razon_social || 'Razón Social'}</div>}
                  {camposEncabezadoCuenta.rfc && <div className="preview-line small">RFC: {infoNegocio.rfc || 'XXXX000000XX0'}</div>}
                  {camposEncabezadoCuenta.telefono && <div className="preview-line small">Tel: {infoNegocio.telefono || '000-000-0000'}</div>}
                  <div className="preview-separator">{'─'.repeat(36)}</div>
                </div>
              </div>

              <div className="config-form-section">
                <div className="config-group">
                  <h3 className="config-group-title">Logo del negocio</h3>
                  <div className="ticket-field-row" style={{ alignItems: 'center' }}>
                    <label className="config-checkbox" style={{ minWidth: 30 }}>
                      <input
                        type="checkbox"
                        checked={logoEnabled}
                        onChange={() => setLogoEnabled(prev => !prev)}
                        disabled={!ticketLogo}
                      />
                      <span className="config-checkmark">
                        {logoEnabled && <FaCheck />}
                      </span>
                    </label>
                    <div className="logo-upload-area">
                      {ticketLogo ? (
                        <div className="logo-preview-container">
                          <img src={ticketLogo} alt="Logo" className="logo-preview-img" />
                          <div className="logo-actions">
                            <label className="config-btn config-btn-secondary" style={{ cursor: 'pointer', margin: 0, padding: '6px 12px', fontSize: 12 }}>
                              <FaUpload /> Cambiar
                              <input type="file" accept="image/*" onChange={handleLogoUpload} style={{ display: 'none' }} />
                            </label>
                            <button className="config-btn config-btn-danger" style={{ padding: '6px 12px', fontSize: 12 }} onClick={handleLogoRemove}>
                              <FaTrash /> Eliminar
                            </button>
                          </div>
                        </div>
                      ) : (
                        <label className="logo-upload-placeholder">
                          <FaImage style={{ fontSize: 28, color: '#bdc3c7' }} />
                          <span>Haz clic para subir un logo</span>
                          <span style={{ fontSize: 11, color: '#95a5a6' }}>PNG, JPG (max 280px ancho)</span>
                          <input type="file" accept="image/*" onChange={handleLogoUpload} style={{ display: 'none' }} />
                        </label>
                      )}
                    </div>
                  </div>
                </div>

                <div className="config-group">
                  <h3 className="config-group-title">Campos del encabezado</h3>
                  {camposConfig.map(campo => (
                    <div className="ticket-field-row" key={campo.key}>
                      <label className="config-checkbox" style={{ minWidth: 30 }}>
                        <input
                          type="checkbox"
                          checked={camposEncabezadoCuenta[campo.key]}
                          onChange={() => setCamposEncabezadoCuenta(prev => ({ ...prev, [campo.key]: !prev[campo.key] }))}
                        />
                        <span className="config-checkmark">
                          {camposEncabezadoCuenta[campo.key] && <FaCheck />}
                        </span>
                      </label>
                      <div className="ticket-field-input">
                        <label className="form-label">{campo.label}</label>
                        <input
                          type="text"
                          className="form-input"
                          value={infoNegocio[campo.key]}
                          onChange={(e) => setInfoNegocio(prev => ({ ...prev, [campo.key]: e.target.value }))}
                          placeholder={campo.placeholder}
                          disabled={!camposEncabezadoCuenta[campo.key]}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="config-form-footer">
                <button className="config-btn config-btn-primary" onClick={handleGuardarEncabezadoCuenta} disabled={guardando}>
                  <FaSave /> {guardando ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          )}
        </div>
      );
    }

    // 3. Fin Ticket Cuenta
    if (vistaActual === 'fin-ticket-cuenta') {
      return (
        <div className="config-content-form">
          {cargandoInfoNegocio ? (
            <div className="loading-platillos"><FaSpinner className="spin" /><span>Cargando...</span></div>
          ) : (
            <div className="ticket-config-layout">
              <div className="ticket-preview-section">
                <h3 className="config-group-title">Vista previa del pie de ticket</h3>
                <div className="ticket-preview">
                  <div className="preview-separator">{'─'.repeat(36)}</div>
                  {finTicketCuenta.linea1 && <div className="preview-line">{finTicketCuenta.linea1}</div>}
                  {finTicketCuenta.linea2 && <div className="preview-line">{finTicketCuenta.linea2}</div>}
                  {finTicketCuenta.linea3 && <div className="preview-line small">{finTicketCuenta.linea3}</div>}
                  {infoNegocio.mensaje_ticket && <div className="preview-line small">{infoNegocio.mensaje_ticket}</div>}
                  {configFacturacion.linkFactura && (
                    <>
                      <div className="preview-separator">{'─'.repeat(36)}</div>
                      {configFacturacion.leyandaInicio && <div className="preview-line small">{configFacturacion.leyandaInicio.split('\n')[0]}</div>}
                      <div className="preview-line small">#TICKET: 000 | TIENDA: XXX</div>
                      <div className="preview-line small">COD.FACT: 0000000000</div>
                      {configFacturacion.Leyenda && <div className="preview-line small">{configFacturacion.Leyenda.split('\n')[0]}</div>}
                    </>
                  )}
                </div>
              </div>

              <div className="config-form-section">
                <div className="config-group">
                  <h3 className="config-group-title">Líneas del pie de ticket</h3>
                  <div className="form-group">
                    <label className="form-label">Línea 1</label>
                    <input
                      type="text" className="form-input"
                      value={finTicketCuenta.linea1}
                      onChange={(e) => setFinTicketCuenta(prev => ({ ...prev, linea1: e.target.value }))}
                      placeholder="Ej: GRACIAS POR SU PREFERENCIA"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Línea 2</label>
                    <input
                      type="text" className="form-input"
                      value={finTicketCuenta.linea2}
                      onChange={(e) => setFinTicketCuenta(prev => ({ ...prev, linea2: e.target.value }))}
                      placeholder="Ej: PROPINAS NO INCLUIDAS"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Línea 3</label>
                    <input
                      type="text" className="form-input"
                      value={finTicketCuenta.linea3}
                      onChange={(e) => setFinTicketCuenta(prev => ({ ...prev, linea3: e.target.value }))}
                      placeholder="Ej: www.minegocio.com"
                    />
                  </div>
                  <div className="form-group" style={{ marginTop: 10 }}>
                    <label className="form-label">Mensaje adicional del ticket</label>
                    <textarea
                      className="form-input"
                      value={infoNegocio.mensaje_ticket}
                      onChange={(e) => setInfoNegocio(prev => ({ ...prev, mensaje_ticket: e.target.value }))}
                      placeholder="Mensaje personalizado al final del ticket"
                      rows={3}
                      style={{ resize: 'vertical', fontFamily: 'inherit' }}
                    />
                  </div>
                </div>

                <div className="config-group">
                  <h3 className="config-group-title">Autofacturación</h3>
                  <div className="config-item" style={{ marginBottom: 15 }}>
                    <label className="config-checkbox">
                      <input
                        type="checkbox"
                        checked={configFacturacion.linkFactura}
                        onChange={() => setConfigFacturacion(prev => ({ ...prev, linkFactura: !prev.linkFactura }))}
                      />
                      <span className="config-checkmark">
                        {configFacturacion.linkFactura && <FaCheck />}
                      </span>
                      <span className="config-label">Activar sección de autofacturación en ticket</span>
                    </label>
                  </div>
                  {configFacturacion.linkFactura && (
                    <>
                      <div className="form-group">
                        <label className="form-label">Leyenda Inicio (antes de datos de facturación)</label>
                        <textarea
                          className="form-input"
                          value={configFacturacion.leyandaInicio}
                          onChange={(e) => setConfigFacturacion(prev => ({ ...prev, leyandaInicio: e.target.value }))}
                          placeholder="Ej: FACTURA TU CONSUMO EN..."
                          rows={3}
                          style={{ resize: 'vertical', fontFamily: 'inherit' }}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Leyenda Final (después de datos de facturación)</label>
                        <textarea
                          className="form-input"
                          value={configFacturacion.Leyenda}
                          onChange={(e) => setConfigFacturacion(prev => ({ ...prev, Leyenda: e.target.value }))}
                          placeholder="Ej: TIENES 72 HORAS PARA FACTURAR..."
                          rows={3}
                          style={{ resize: 'vertical', fontFamily: 'inherit' }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="config-form-footer">
                <button className="config-btn config-btn-primary" onClick={handleGuardarFinCuenta} disabled={guardando}>
                  <FaSave /> {guardando ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          )}
        </div>
      );
    }

    // 4. Encabezado Ticket Reporte
    if (vistaActual === 'encabezado-ticket-reporte') {
      return (
        <div className="config-content-form">
          {cargandoInfoNegocio ? (
            <div className="loading-platillos"><FaSpinner className="spin" /><span>Cargando...</span></div>
          ) : (
            <div className="ticket-config-layout">
              <div className="ticket-preview-section">
                <h3 className="config-group-title">Vista previa del encabezado de reporte</h3>
                <div className="ticket-preview">
                  {encabezadoReporte.mostrarNombreNegocio && <div className="preview-line bold">{infoNegocio.nombre_negocio || 'NOMBRE DEL NEGOCIO'}</div>}
                  {encabezadoReporte.mostrarSucursal && <div className="preview-line">{infoNegocio.nombre_sucursal || 'SUCURSAL'}</div>}
                  {encabezadoReporte.mostrarDireccion && <div className="preview-line small">{infoNegocio.direccion_linea1 || 'Dirección'}</div>}
                  {encabezadoReporte.mostrarRFC && <div className="preview-line small">RFC: {infoNegocio.rfc || 'XXXX000000XX0'}</div>}
                  <div className="preview-line bold">** CORTE DE CAJA **</div>
                  <div className="preview-separator">{'─'.repeat(36)}</div>
                </div>
              </div>

              <div className="config-form-section">
                <div className="config-group">
                  <h3 className="config-group-title">Campos a mostrar en reportes</h3>
                  {[
                    { key: 'mostrarNombreNegocio', label: 'Nombre del negocio' },
                    { key: 'mostrarSucursal', label: 'Nombre de sucursal' },
                    { key: 'mostrarDireccion', label: 'Dirección' },
                    { key: 'mostrarRFC', label: 'RFC' }
                  ].map(campo => (
                    <div className="config-item" key={campo.key} style={{ marginBottom: 8 }}>
                      <label className="config-checkbox">
                        <input
                          type="checkbox"
                          checked={encabezadoReporte[campo.key]}
                          onChange={() => setEncabezadoReporte(prev => ({ ...prev, [campo.key]: !prev[campo.key] }))}
                        />
                        <span className="config-checkmark">
                          {encabezadoReporte[campo.key] && <FaCheck />}
                        </span>
                        <span className="config-label">{campo.label}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="config-form-footer">
                <button className="config-btn config-btn-primary" onClick={handleGuardarEncabezadoReporte} disabled={guardando}>
                  <FaSave /> {guardando ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          )}
        </div>
      );
    }

    // 5. Fin Ticket Reporte
    if (vistaActual === 'fin-ticket-reporte') {
      return (
        <div className="config-content-form">
          <div className="ticket-config-layout">
            <div className="ticket-preview-section">
              <h3 className="config-group-title">Vista previa del pie de reporte</h3>
              <div className="ticket-preview">
                <div className="preview-separator">{'─'.repeat(36)}</div>
                {finTicketReporte.linea1 && <div className="preview-line">{finTicketReporte.linea1}</div>}
                {finTicketReporte.linea2 && <div className="preview-line">{finTicketReporte.linea2}</div>}
                {finTicketReporte.mostrarLineaFirma && (
                  <>
                    <div className="preview-line">&nbsp;</div>
                    <div className="preview-line">{'_'.repeat(28)}</div>
                    <div className="preview-line small">{finTicketReporte.textoFirma || 'Firma del Responsable'}</div>
                  </>
                )}
              </div>
            </div>

            <div className="config-form-section">
              <div className="config-group">
                <h3 className="config-group-title">Líneas del pie de reporte</h3>
                <div className="form-group">
                  <label className="form-label">Línea 1</label>
                  <input
                    type="text" className="form-input"
                    value={finTicketReporte.linea1}
                    onChange={(e) => setFinTicketReporte(prev => ({ ...prev, linea1: e.target.value }))}
                    placeholder="Ej: Reporte generado automáticamente"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Línea 2</label>
                  <input
                    type="text" className="form-input"
                    value={finTicketReporte.linea2}
                    onChange={(e) => setFinTicketReporte(prev => ({ ...prev, linea2: e.target.value }))}
                    placeholder="Texto adicional"
                  />
                </div>
              </div>

              <div className="config-group">
                <h3 className="config-group-title">Línea de firma</h3>
                <div className="config-item">
                  <label className="config-checkbox">
                    <input
                      type="checkbox"
                      checked={finTicketReporte.mostrarLineaFirma}
                      onChange={() => setFinTicketReporte(prev => ({ ...prev, mostrarLineaFirma: !prev.mostrarLineaFirma }))}
                    />
                    <span className="config-checkmark">
                      {finTicketReporte.mostrarLineaFirma && <FaCheck />}
                    </span>
                    <span className="config-label">Mostrar línea de firma</span>
                  </label>
                </div>
                {finTicketReporte.mostrarLineaFirma && (
                  <div className="form-group" style={{ marginTop: 12 }}>
                    <label className="form-label">Texto debajo de la firma</label>
                    <input
                      type="text" className="form-input"
                      value={finTicketReporte.textoFirma}
                      onChange={(e) => setFinTicketReporte(prev => ({ ...prev, textoFirma: e.target.value }))}
                      placeholder="Ej: Firma del Responsable"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="config-form-footer">
              <button className="config-btn config-btn-primary" onClick={handleGuardarFinReporte} disabled={guardando}>
                <FaSave /> {guardando ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      );
    }

    // Precio de delivery
    if (vistaActual === 'platillos-config') {
      return <PrecioDelivery />;
    }

    // Contenido placeholder para otras vistas
    const placeholderContent = {
      'autorizacion-supervisor': { icon: FaUsers, title: "Autorización del Supervisor", desc: "Gestión de permisos y autorizaciones del supervisor" },
      // Cuentas
      'pestana-default': { icon: FaUser, title: "Pestaña Default", desc: "Configuración de pestaña por defecto del sistema" },
      'agrupar-productos': { icon: FaUser, title: "Agrupar Productos y Mostrar Existentes", desc: "Configuración de agrupación y visualización de productos" },
      'inicio-cuenta-mesa': { icon: FaUser, title: "Inicio de Cuenta o Mesa", desc: "Configuración del inicio de cuentas y mesas" },
      'confirmar-pago': { icon: FaUser, title: "Confirmar Pago al Imprimir Ticket", desc: "Configuración de confirmación de pagos" },
      'modo-cooperativo': { icon: FaUser, title: "Modo Cooperativo", desc: "Configuración del modo cooperativo del sistema" },
      'observaciones': { icon: FaUser, title: "Observaciones", desc: "Configuración de observaciones en el sistema" },
      'existencia-platillos': { icon: FaUser, title: "Existencia de Platillos", desc: "Configuración de control de existencias" },
      'preparados': { icon: FaUser, title: "Preparados", desc: "Configuración de platillos preparados" },
      'disponibilidad-productos': { icon: FaUser, title: "Disponibilidad de Productos", desc: "Configuración de disponibilidad de productos" },
      'pagos-pendientes': { icon: FaUser, title: "Pagos Pendientes", desc: "Configuración de gestión de pagos pendientes" },
      // Tickets
      'orden-productos-reportes': { icon: FaTicketAlt, title: "Orden de Productos Reportes", desc: "Configuración del orden de productos en reportes" },
      'encabezado-ticket-cuenta': { icon: FaTicketAlt, title: "Encabezado Ticket Cuenta", desc: "Configuración del encabezado de tickets de cuenta" },
      'fin-ticket-cuenta': { icon: FaTicketAlt, title: "Fin Ticket Cuenta", desc: "Configuración del pie de tickets de cuenta" },
      'encabezado-ticket-reporte': { icon: FaTicketAlt, title: "Encabezado Ticket Reporte", desc: "Configuración del encabezado de tickets de reporte" },
      'fin-ticket-reporte': { icon: FaTicketAlt, title: "Fin Ticket Reporte", desc: "Configuración del pie de tickets de reporte" },
      // Caja
      'fondo-de-caja': { icon: FaCashRegister, title: "Fondo de Caja", desc: "Configuración del fondo de caja inicial" },
      // Imprimir
      'impresion-ticket': { icon: FaPrint, title: "Impresión de Ticket", desc: "Configuración de impresión de tickets" },
      'iva-ticket': { icon: FaPrint, title: "IVA en Ticket", desc: "Configuración de IVA en tickets" },
      'numero-operacion-ticket': { icon: FaPrint, title: "Número de Operación en Ticket", desc: "Configuración de número de operación" },
      'impresora-predeterminada': { icon: FaPrint, title: "Impresora Predeterminada", desc: "Configuración de impresora por defecto" },
      'impresion-platillo': { icon: FaPrint, title: "Impresión por Platillo", desc: "Configuración de impresión por platillo" },
      'imprimir-copia': { icon: FaPrint, title: "Imprimir Copia", desc: "Configuración de impresión de copias" },
      'impresion-comandas': { icon: FaPrint, title: "Impresión de Comandas", desc: "Configuración de impresión de comandas" },
      // Diseño
      'configurar-diseno': { icon: FaPalette, title: "Configurar Diseño", desc: "Personalización y configuración de la interfaz del sistema" },
      // Tarjeta de Crédito
      'configurar-comision': { icon: FaCreditCard, title: "Configurar Comisión", desc: "Configuración de comisiones para pagos con tarjeta de crédito" },
      // Otros módulos
      modulos: { icon: FaCubes, title: "Módulos", desc: "Gestión de módulos del sistema" },
      'registrar-ip-equipo': { icon: FaCubes, title: "Registrar IP y Equipo", desc: "Registro y configuración de direcciones IP y equipos autorizados" },
      email: { icon: FaEnvelope, title: "Enviar Corte Email", desc: "Configuración de envío de reportes" },
      'configuracion-email': { icon: FaEnvelope, title: "Configuración de Email", desc: "Configuración de servidor SMTP y correos para envío de cortes" },
      compras: { icon: FaShoppingCart, title: "Compras", desc: "Configuración del módulo de compras" },
      'costos-ingrediente': { icon: FaShoppingCart, title: "Costos de Ingrediente", desc: "Configuración y gestión de costos de ingredientes para el sistema de compras" },
      configuracion: { icon: FaCogs, title: "Configuración", desc: "Configuraciones generales del sistema" },
      'opciones-corte': { icon: FaCogs, title: "Opciones de Corte", desc: "Configuración de opciones y parámetros para el corte de caja" },
      'platillos-config': { icon: FaCogs, title: "Platillos", desc: "Configuración general de platillos del sistema" },
      'previsualizar-comandas': { icon: FaCogs, title: "Previsualizar Comandas", desc: "Vista previa y configuración del formato de comandas" },
      gastos: { icon: FaDollarSign, title: "Gastos", desc: "Configuración del módulo de gastos" },
      'gastos-config': { icon: FaDollarSign, title: "Gastos", desc: "Configuración y gestión de gastos del sistema" },
      // Biométrico
      'configuracion-biometrico': { icon: FaFingerprint, title: "Configuración Biométrico", desc: "Configuración del dispositivo biométrico ZKTeco para control de asistencia" },
      'configuracion-licencia': { icon: FaShieldAlt, title: "Licencia del Sistema", desc: "Activación y verificación de la licencia del sistema" },
      'configuracion-actualizaciones': { icon: FaCogs, title: "Actualizaciones", desc: "Configuración del servidor de actualizaciones del sistema" }
    };

    const current = placeholderContent[vistaActual] || placeholderContent['autorizacion-supervisor'];
    const IconComponent = current.icon;

    return (
      <div className="config-content-placeholder">
        <IconComponent className="placeholder-icon" />
        <h2>{current.title}</h2>
        <p>{current.desc}</p>
      </div>
    );
  };

  return (
    <div className="configuracion-wrapper">
      <Header
        titulo='Configuración'
        color='#2c3e50'
      />

      <div className="configuracion-container">
        {/* Overlay oscuro en pantallas pequeñas cuando el menú está abierto */}
        {menuAbierto && window.innerWidth <= 1024 && (
          <div
            onClick={() => setMenuAbierto(false)}
            style={{
              position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)',
              zIndex: 499, cursor: 'pointer'
            }}
          />
        )}

        {/* Menú lateral */}
        <div className={`menu-lateral ${menuAbierto ? 'abierto' : 'cerrado'}`}>
          <div className="menu-header">
            <button className="toggle-menu" onClick={toggleMenu}>
              <FaBars />
            </button>
            <span className="menu-titulo">Configuración</span>
          </div>

          <div className="menu-items">
            {/* Supervisor */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('supervisor')}>
                {itemsColapsados.supervisor ? <FaChevronRight /> : <FaChevronDown />}
                <span>Supervisor</span>
              </div>
              {!itemsColapsados.supervisor && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'autorizacion-supervisor' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('autorizacion-supervisor')}
                  >
                    Autorización del Supervisor
                  </div>
                </div>
              )}
            </div>

            {/* Cuentas */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('cuentas')}>
                {itemsColapsados.cuentas ? <FaChevronRight /> : <FaChevronDown />}
                <span>Cuentas</span>
              </div>
              {!itemsColapsados.cuentas && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'pestana-default' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('pestana-default')}
                  >
                    Pestaña default
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'agrupar-productos' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('agrupar-productos')}
                  >
                    Agrupar productos y mostrar existentes
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'inicio-cuenta-mesa' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('inicio-cuenta-mesa')}
                  >
                    Inicio de cuenta o mesa
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'confirmar-pago' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('confirmar-pago')}
                  >
                    Confirmar pago al imprimir el ticket
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'modo-cooperativo' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('modo-cooperativo')}
                  >
                    Modo cooperativo
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'observaciones' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('observaciones')}
                  >
                    Observaciones
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'existencia-platillos' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('existencia-platillos')}
                  >
                    Existencia de platillos
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'preparados' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('preparados')}
                  >
                    Preparados
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'disponibilidad-productos' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('disponibilidad-productos')}
                  >
                    Disponibilidad de productos
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'pagos-pendientes' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('pagos-pendientes')}
                  >
                    Pagos pendientes
                  </div>
                </div>
              )}
            </div>

            {/* Tickets */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('tickets')}>
                {itemsColapsados.tickets ? <FaChevronRight /> : <FaChevronDown />}
                <span>Tickets</span>
              </div>
              {!itemsColapsados.tickets && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'orden-productos-reportes' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('orden-productos-reportes')}
                  >
                    Orden de productos reportes
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'encabezado-ticket-cuenta' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('encabezado-ticket-cuenta')}
                  >
                    Encabezado ticket cuenta
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'fin-ticket-cuenta' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('fin-ticket-cuenta')}
                  >
                    Fin ticket cuenta
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'encabezado-ticket-reporte' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('encabezado-ticket-reporte')}
                  >
                    Encabezado ticket reporte
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'fin-ticket-reporte' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('fin-ticket-reporte')}
                  >
                    Fin ticket reporte
                  </div>
                </div>
              )}
            </div>

            {/* Caja */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('caja')}>
                {itemsColapsados.caja ? <FaChevronRight /> : <FaChevronDown />}
                <span>Caja</span>
              </div>
              {!itemsColapsados.caja && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'fondo-de-caja' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('fondo-de-caja')}
                  >
                    Fondo de caja
                  </div>
                </div>
              )}
            </div>

            {/* Imprimir */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('imprimir')}>
                {itemsColapsados.imprimir ? <FaChevronRight /> : <FaChevronDown />}
                <span>Imprimir</span>
              </div>
              {!itemsColapsados.imprimir && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'impresion-ticket' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('impresion-ticket')}
                  >
                    Impresión de ticket
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'iva-ticket' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('iva-ticket')}
                  >
                    IVA en ticket
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'numero-operacion-ticket' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('numero-operacion-ticket')}
                  >
                    Número de operación en ticket
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'impresora-predeterminada' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('impresora-predeterminada')}
                  >
                    Impresora predeterminada
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'impresion-platillo' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('impresion-platillo')}
                  >
                    Impresión por platillo
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'imprimir-copia' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('imprimir-copia')}
                  >
                    Imprimir copia
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'impresion-comandas' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('impresion-comandas')}
                  >
                    Impresión de comandas
                  </div>
                </div>
              )}
            </div>

            {/* Diseño */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('diseno')}>
                {itemsColapsados.diseno ? <FaChevronRight /> : <FaChevronDown />}
                <span>Diseño</span>
              </div>
              {!itemsColapsados.diseno && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'configurar-diseno' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('configurar-diseno')}
                  >
                    Configurar diseño
                  </div>
                </div>
              )}
            </div>

            {/* Tarjeta de Crédito */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('tarjeta')}>
                {itemsColapsados.tarjeta ? <FaChevronRight /> : <FaChevronDown />}
                <span>Tarjeta de Crédito</span>
              </div>
              {!itemsColapsados.tarjeta && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'configurar-comision' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('configurar-comision')}
                  >
                    Configurar comisión
                  </div>
                </div>
              )}
            </div>

            {/* Módulos */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('modulos')}>
                {itemsColapsados.modulos ? <FaChevronRight /> : <FaChevronDown />}
                <span>Módulos</span>
              </div>
              {!itemsColapsados.modulos && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'registrar-ip-equipo' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('registrar-ip-equipo')}
                  >
                    Registrar IP y Equipo
                  </div>
                </div>
              )}
            </div>

            {/* Enviar corte email */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('email')}>
                {itemsColapsados.email ? <FaChevronRight /> : <FaChevronDown />}
                <span>Enviar corte email</span>
              </div>
              {!itemsColapsados.email && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'configuracion-email' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('configuracion-email')}
                  >
                    Configuración
                  </div>
                </div>
              )}
            </div>

            {/* Compras */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('compras')}>
                {itemsColapsados.compras ? <FaChevronRight /> : <FaChevronDown />}
                <span>Compras</span>
              </div>
              {!itemsColapsados.compras && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'costos-ingrediente' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('costos-ingrediente')}
                  >
                    Costos de ingrediente
                  </div>
                </div>
              )}
            </div>

            {/* Configuración */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('configuracion')}>
                {itemsColapsados.configuracion ? <FaChevronRight /> : <FaChevronDown />}
                <span>Configuración</span>
              </div>
              {!itemsColapsados.configuracion && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'opciones-corte' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('opciones-corte')}
                  >
                    Opciones de corte
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'platillos-config' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('platillos-config')}
                  >
                    Precio Delivery
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'previsualizar-comandas' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('previsualizar-comandas')}
                  >
                    Previsualizar comandas
                  </div>
                </div>
              )}
            </div>

            {/* Gastos */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('gastos')}>
                {itemsColapsados.gastos ? <FaChevronRight /> : <FaChevronDown />}
                <span>Gastos</span>
              </div>
              {!itemsColapsados.gastos && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'gastos-config' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('gastos-config')}
                  >
                    Gastos
                  </div>
                </div>
              )}
            </div>

            {/* Biométrico */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('biometrico')}>
                {itemsColapsados.biometrico ? <FaChevronRight /> : <FaChevronDown />}
                <span>Biométrico</span>
              </div>
              {!itemsColapsados.biometrico && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'configuracion-biometrico' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('configuracion-biometrico')}
                  >
                    Configuración ZKTeco
                  </div>
                </div>
              )}
            </div>

            {/* Licencia */}
            <div className="menu-item">
              <div className="menu-item-header" onClick={() => toggleMenuItem('licencia')}>
                {itemsColapsados.licencia ? <FaChevronRight /> : <FaChevronDown />}
                <span>Licencia</span>
              </div>
              {!itemsColapsados.licencia && (
                <div className="submenu">
                  <div
                    className={`submenu-item ${vistaActual === 'configuracion-licencia' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('configuracion-licencia')}
                  >
                    Configuración de Licencia
                  </div>
                  <div
                    className={`submenu-item ${vistaActual === 'configuracion-actualizaciones' ? 'activo' : ''}`}
                    onClick={() => cambiarVista('configuracion-actualizaciones')}
                  >
                    Actualizaciones
                  </div>
                </div>
              )}
            </div>

            {/* Salir */}
            <div className="menu-item">
              <div className="menu-item-header salir" onClick={() => window.history.back()}>
                <span>Salir</span>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido principal */}
        <div className="configuracion-content">
          <div className="configuracion-inner">
            <div className="configuracion-header" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {/* Botón para abrir el menú — solo visible en pantallas ≤1024px */}
              <button className="toggle-menu-flotante" onClick={() => setMenuAbierto(true)} title="Menú">
                <FaBars />
              </button>
              <h1 className="configuracion-titulo">
                {vistaActual === 'autorizacion-supervisor' ? 'Autorización del Supervisor' :
                 vistaActual === 'pestana-default' ? 'Pestaña Default' :
                 vistaActual === 'agrupar-productos' ? 'Agrupar Productos y Mostrar Existentes' :
                 vistaActual === 'inicio-cuenta-mesa' ? 'Inicio de Cuenta o Mesa' :
                 vistaActual === 'confirmar-pago' ? 'Confirmar Pago al Imprimir Ticket' :
                 vistaActual === 'modo-cooperativo' ? 'Modo Cooperativo' :
                 vistaActual === 'observaciones' ? 'Observaciones' :
                 vistaActual === 'existencia-platillos' ? 'Existencia de Platillos' :
                 vistaActual === 'preparados' ? 'Preparados' :
                 vistaActual === 'disponibilidad-productos' ? 'Disponibilidad de Productos' :
                 vistaActual === 'pagos-pendientes' ? 'Pagos Pendientes' :
                 vistaActual === 'orden-productos-reportes' ? 'Orden de Productos Reportes' :
                 vistaActual === 'encabezado-ticket-cuenta' ? 'Encabezado Ticket Cuenta' :
                 vistaActual === 'fin-ticket-cuenta' ? 'Fin Ticket Cuenta' :
                 vistaActual === 'encabezado-ticket-reporte' ? 'Encabezado Ticket Reporte' :
                 vistaActual === 'fin-ticket-reporte' ? 'Fin Ticket Reporte' :
                 vistaActual === 'fondo-de-caja' ? 'Fondo de Caja' :
                 vistaActual === 'impresion-ticket' ? 'Impresión de Ticket' :
                 vistaActual === 'iva-ticket' ? 'IVA en Ticket' :
                 vistaActual === 'numero-operacion-ticket' ? 'Número de Operación en Ticket' :
                 vistaActual === 'impresora-predeterminada' ? 'Impresora Predeterminada' :
                 vistaActual === 'impresion-platillo' ? 'Impresión por Platillo' :
                 vistaActual === 'imprimir-copia' ? 'Imprimir Copia' :
                 vistaActual === 'impresion-comandas' ? 'Impresión de Comandas' :
                 vistaActual === 'configurar-diseno' ? 'Configurar Diseño' :
                 vistaActual === 'configurar-comision' ? 'Configurar Comisión' :
                 vistaActual === 'modulos' ? 'Configuración de Módulos' :
                 vistaActual === 'registrar-ip-equipo' ? 'Registrar IP y Equipo' :
                 vistaActual === 'email' ? 'Configuración de Envío de Email' :
                 vistaActual === 'configuracion-email' ? 'Configuración de Email' :
                 vistaActual === 'compras' ? 'Configuración de Compras' :
                 vistaActual === 'costos-ingrediente' ? 'Costos de Ingrediente' :
                 vistaActual === 'configuracion' ? 'Configuración General' :
                 vistaActual === 'opciones-corte' ? 'Opciones de Corte' :
                 vistaActual === 'platillos-config' ? 'Precio Delivery' :
                 vistaActual === 'previsualizar-comandas' ? 'Previsualizar Comandas' :
                 vistaActual === 'gastos' ? 'Configuración de Gastos' :
                 vistaActual === 'gastos-config' ? 'Gastos' :
                 vistaActual === 'configuracion-biometrico' ? 'Configuración Biométrico ZKTeco' :
                 vistaActual === 'configuracion-licencia' ? 'Licencia del Sistema' :
                 vistaActual === 'configuracion-actualizaciones' ? 'Actualizaciones del Sistema' :
                 'Configuración'}
              </h1>
            </div>

            {renderContenido()}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Configuracion;